import {
  Button,
  Box,
  Flex,
  Icon,
  Text,
  useColorModeValue,
  useColorMode,
  useDisclosure,
  Img,
  Menu,
  MenuButton,
  MenuList,
  FormControl,
  FormLabel,
  Textarea,
  MenuItem,
  Select,
  GridItem,
  Grid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useToast,
  Checkbox,
} from '@chakra-ui/react';
import { Children, lazy } from 'react';
import { LazyMotion, domAnimation, motion, m, domMax } from 'framer-motion';
import React, {
  Suspense,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  createContext,
  useContext,
} from 'react';

import { AiFillMessage } from 'react-icons/ai';
import { getTestAudios, updatePreviewlogs } from 'utils/game/gameService';
import { getImages } from 'utils/game/gameService';

import {
  // getVoiceMessage,
  getPreview,
  getGameLanguages,
  getContentRelatedLanguage,
  SubmitReview,
} from 'utils/game/gameService';

import { ScoreContext } from './GamePreview';

import { useParams } from 'react-router-dom';
import { ProfileType } from './GamePreview';
import LoadImg from 'assets/img/games/load.jpg';
import { useDispatch } from 'react-redux';
import {
  resetGameModifiedState,
  updatePreviewData,
} from 'store/preview/previewSlice';

import ReplayScore from './playcards/ReplayScore';
import Story from './playcards/Story';
import Welcome from './playcards/Welcome';
import ThankYou from './playcards/Thankyou';
import Overview from './playcards/Overview';
import Reflection from './playcards/Reflection';
import Takeway from './playcards/Takeaway';
import Completion from './playcards/Completion';
import ReplayGame from './playcards/ReplayGame';
import PlayInfo from './playcards/playinfo';
import LeaderBoard from './playcards/Leaderboard';

import ProfileScreen from './playcards/ProfileScreen';
import Characterspage from './playcards/CharacterSelection';
import ChapterPage from './playcards/Chapters';
import FeedBackScreen from './playcards/FeedBackScreen';
import TopMenuBar from './playcards/TopMenuBar';
import GameIntroScreen from './playcards/GameIntroScreen';
import ModelPopup from './playcards/ModelPopup';

import ReplayPoints from './playcards/ReplayPoints';
import Player from './playcards/Player';
import ModelPlayer from './playcards/Model';

import { promptType } from './GamePreview';
import CompletionReview from './playcards/CompleteReviewPrompt';
import {
  checkIsMandatoryReplayPromptRequired,
  isOptionalReplayAllow,
  getPlayerFinalScore,
} from './HelperFunctions';

const BackgroundGLB = lazy(() => import('./playcards/BackgroundFeedback'));
const Emporium = lazy(() => import('./playcards/Emporium'));
const FurturisticCity = lazy(() => import('./playcards/furturisticCity'));
const FuturisticOffice = lazy(() => import('./playcards/futuristicOffice'));
const FuturistiLab = lazy(() => import('./playcards/futuristiLab'));
const Castle = lazy(() => import('./playcards/castle'));
const Office = lazy(() => import('./playcards/office'));
const Underground = lazy(() => import('./playcards/underground'));
const MagicalGarden = lazy(() => import('./playcards/MagicalGarden'));
const RealisticOffice = lazy(() => import('./playcards/RealisticOffice'));
const RealFactory = lazy(() => import('./playcards/RealFactory'));
const RealWorkplace = lazy(() => import('./playcards/RealWorkplace'));
const FutureThemeLab = lazy(() => import('./playcards/FutureThemeLab'));
const FutureThemeWorkshop = lazy(() => import('./playcards/FutureThemeWorkshop'));
const FutureThemeLab1 = lazy(() => import('./playcards/FutureThemeLab1'));
const FutureThemeWorkShop1 = lazy(() => import('./playcards/FutureThemeWorkShop1'));

interface Review {
  reviewerId: String | null;
  reviewGameId: String | null;
  reviewid: any;
  review: String | null;
  tabId: Number | null;
  tabAttribute: String | null;
  tabAttributeValue: String | null;
  completeStatus: any;
}

interface ShowPreviewProps {
  gameInfo: any;
  isReviewDemo: boolean;
  currentScore: any;
  setCurrentScore: any;
  preloadedAssets: any;
  InitialScreenId: number;
  fetchGameData: () => void;
  fetchPreviewLogsData: () => void;
  previewLogsDataIni: any;
  preLogDatasIni: any;
  initialStateUpdate: boolean;
  setInitialStateUpdate: any;
  creatorDataSlice: any;
  promptType: promptType;
  setGameInfo: any;
  setIsAuthFailed: any;
  isAuthFailed: any;
  fetchCreatorDemoData: () => void;
  isLoading: any;
  glbName: any;
  selectedBackground: any;
}

// Define the interface for the state
interface PrevLogData {
  previewLogId: string;
  playerId: string;
  playerType: string;
  previewGameId: string;
  nevigatedSeq: any[];
  screenIdSeq: any[];
  lastActiveBlockSeq: any;
  selectedOptions: any;
  previewProfile: any;
  lastModifiedBlockSeq: string;
  lastBlockModifiedDate: string;
  updatedAt: string;
  playerInputs: any;
  audioVolumeValue: any | null;
  previewScore: ProfileType;
  questState: any;
}

type TabAttributeSet = {
  [key: string]: {
    tabAttribute: string | null;
    tabAttributeValue: string | null;
  };
};
//no need for story
const overOptions = [
  { value: 1, label: 'Background' },
  { value: 2, label: 'Characters' },
  { value: 3, label: 'Game Overview' },
  { value: 4, label: 'Story' },
  { value: 5, label: 'Design' },
];

const tabOptions = [
  { value: 1, label: 'Background' },
  { value: 2, label: 'Characters' },
  { value: 3, label: 'Game Overview' },
  { value: 4, label: 'Story' },
  { value: 5, label: 'Design' },
];

interface ProfileDataType {
  name?: string;
  gender?: string;
  selectedplayer?: string;
  language?: any;
  score?: any;
  allTimeScore?: any;
  content?: any;
  audioUrls?: any;
  textId?: any;
  fieldName?: any;
  [x: string]: any;
}

/**This can access through out the demoplay, to enable/ disable the review button */
const skipScreenList = [0, 8, 9, 10, 11, 12, 13, 15, 16];
export const ProfileContext = createContext<ProfileDataType>({
  name: '',
  gender: '',
  selectedplayer: '',
  language: '',
  score: 350,
  allTimeScore: 950,
});
type QuestWiseMaxTotal = { [key: number]: number };
const EntirePreview: React.FC<ShowPreviewProps> = ({
  gameInfo,
  isReviewDemo,

  setCurrentScore,
  preloadedAssets,
  InitialScreenId,

  previewLogsDataIni,
  preLogDatasIni,

  creatorDataSlice,
  promptType,

  setIsAuthFailed,
  isAuthFailed,
  fetchCreatorDemoData,
  isLoading,
  glbName,
  selectedBackground,
}) => {
  const user: any = JSON.parse(localStorage.getItem('user'));

  const { id } = useParams();
  const { reviewid } = useParams();
  const { previewid } = useParams();
  const Gameid = id ? id : null;
const audioFiles = {
  Antoni: require("../../../../../assets/adiuo/Antoni.mp3"),
  Bill: require("../../../../../assets/adiuo/Bill.mp3"),
  Josh: require("../../../../../assets/adiuo/Josh.mp3"),
  Nicole: require("../../../../../assets/adiuo/Nicole.mp3"),
  Serena: require("../../../../../assets/adiuo/Serena.mp3"),
  IntroMusic: require("../../../../../assets/adiuo/intromusicone.mp3")
};
  const audioRef = React.useRef(null);
  const musicRef = React.useRef(null);

   useEffect(() => {
    if (isLoading) {
      // 🎵 Play Bill’s music when loader starts
      musicRef.current = new Audio(audioFiles.IntroMusic);
      musicRef.current.loop = true; // optional looping
      musicRef.current.volume = 0.8; // optional volume control (0–1)
      musicRef.current.play().catch((err:any) => {
        console.warn("Autoplay blocked by browser:", err);
      });
    } else {
      // ⏹️ Stop music when loader ends
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    }

    // 🧹 Cleanup on unmount
    return () => {
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    };
  }, [isLoading]);


  const dispatch = useDispatch();
  //state added by rajesh for profile screen
  const [isLanguage, setIsLanguage] = useState(null);
  // selected option color change
  const [selectedOption, setSelectedOption] = useState(null);
  // handle the item
  const [item, setItem] = useState(null);
  // handle the data to show
  const [data, setData] = useState(null);
  // handle the transition effect
  const [showNote, setShowNote] = useState(false),
    [first, setFirst] = useState(false);
  // type to render component ( conditional render)
  const [type, setType] = useState<string>('');
  // handle the choosed option's response message and feedback content and navigation
  const [resMsg, setResMsg] = useState<string>('');
  const [feed, setFeed] = useState<string>('');
  const [navi, setNavi] = useState<string>('');
  const [options, setOptions] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [optionNavigation, setOptionNavigation] = useState(null);
  const [getSelectedOptions, SetgetSelectedOptions] = useState<any>({});

  /** This state handles the Review Form Tab and Sub Tab options */
  const [reviewTabOptions, setReviewTabOptions] = useState([]);

  const [filteredTabOptions, setFilteredTabOptions] = useState([]);
  // Feed back after completion
  const [FeedbackcurrentPosition, setFeedbackCurrentPosition] = useState(0);
  const [interactionBlockArray, setInterActionBlockArray] = useState<any | []>(
    [],
  );
  const [FeedbackremainingSentences, setFeedbackRemainingSentences] = useState<
    any[]
  >([]);
  const [InterActionScore, setInterActionScore] = useState<any[]>([]);
  const [FeedbackNavigatenext, setFeedbackNavigateNext] = useState<any>(false);
  const [isScreenshot, setisScreenshot] = useState<any>(false);
  const [FeedBackoptionData, setFeedBackoptionData] = useState(null);
  const [FeedBackselectedoptionData, setFeedBackSelectedoptionData] =
    useState(null);
  const [isOptionalReplay, setisOptionalReplay] = useState<any>(false);
  const [isReplay, setisReplay] = useState<any>(false);
  const [profilescore, Setprofilescore] = useState(null);
  const [reviewSubTabOptions, setReviewSubTabOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [reviewInput, setReviewInput] = useState<Review>({
    reviewerId: gameInfo?.reviewer?.ReviewerId ?? null,
    reviewGameId: gameInfo?.gameId ?? null,
    reviewid: reviewid ?? null,
    review: '',
    tabId: null,
    tabAttribute: '',
    tabAttributeValue: '',
    completeStatus: 'No',
  });
  const [isLeaderboardEnabled, setIsLeaderboardEnabled] = useState(false);

  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [audio, setAudio] = useState<string>('');

  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const [demoBlocks, setDemoBlocks] = useState(null);
  const Tab5attribute = [6, 4, 3, 7, 1, 5];

  const [currentQuestNo, setCurrentQuestNo] = useState(1);
  const [homeLeaderBoard, setHomeLeaderBoard] = useState(null);
  const { profile, setProfile } = useContext(ScoreContext);
  const tabAttributeSets: TabAttributeSet[] = [
    { '1': { tabAttribute: null, tabAttributeValue: null } },
    { '2': { tabAttribute: null, tabAttributeValue: null } },
    { '3': { tabAttribute: 'fieldName', tabAttributeValue: '' } },
    { '4': { tabAttribute: 'blockSeqId', tabAttributeValue: '' } },
    { '5': { tabAttribute: 'screenId', tabAttributeValue: '' } },
  ];
  const [backgroundtheme, setBackgroundTheme] = useState<any>();
  const [isPrevNavigation, setIsPrevNavigation] = useState(false);
  const [replayIsOpen, setReplayIsOpen] = useState(null);

  const scoreComp =
    profile?.score !== undefined
      ? profile?.score?.length > 0
        ? profile?.score[0]?.score
        : 0
      : 0;

  const [questWiseMaxTotal, setQuestWiseMaxTotal] =
    useState<QuestWiseMaxTotal>();
  const [ModelControl, setModelControl] = useState<boolean>(false); // for model show

  const [isStoryScreen, isSetStoryScreen] = useState<boolean>(false);
  const [OptionSelectId, setOptionSelectId] = useState(null);

  const [playerTodayScore, setPlayerTodayScore] = useState<any>(null);
  const [profileData, setProfileData] = useState<ProfileDataType>({
    name: previewid ? profile?.PlayerName ?? '' : '',
    gender: previewid ? profile?.playerGender ?? '' : '',
    selectedplayer: '',
    language: '',
    score: '',
    allTimeScore: 250,
    content: '',
    audioUrls: '',
    textId: '',
    fieldName: '',
    Audiogetlanguage: [],
  });
  const [replayState, setReplayState] = useState<string>(null);

  const [firstLoading, setFirstLoading] = useState<boolean>(true);

  const [isZoomComplete, setIsZoomComplete] = useState(false);

  const [getPrevLogDatas, setPreLogDatas] = useState<PrevLogData>({
    ...preLogDatasIni,
  });
  const [voiceIds, setVoiceIds] = useState<any>();
  const [feedbackList, setFeedbackList] = useState([]);
  const [interactionCount, setinteractionCount] = useState(null);
  const [isGetsPlayAudioConfirmation, setIsGetsPlayAudioConfirmation] =
    useState<boolean>(false);
  const [reflectionAnswers, setReflectionAnswers] = useState([]);
  const [resolution, setResolution] = useState(null);
  const [navTrack, setNavTrack] = useState([]);
  const [currentTrackPointer, setCurrentTrackPointer] = useState(0);
  const [currentScreenId, setCurrentScreenId] =
    useState<number>(InitialScreenId);
  const [modalLoaded, setModalLoaded] = useState<any>(false);

  const [hasMulitLanguages, setHasMulitLanguages] = useState<boolean>(false); // This state to control the auto Initialization of the Language selection Modal popup
  const [isOpenCustomModal, setIsOpenCustomModal] = useState<boolean>(false); //This state to control the opening of Language selection Modal popup by click event
  const [gameLanguages, setGameLanguages] = useState([]);
  const [NavigateBlockEmpty, setNavigateBlockEmpty] = useState<boolean>(false);

  const [RepeatSelectOption, setRepeatSelectOption] = useState<boolean>(false);
  const [RepeatPrevOption, setRepeatPrevOption] = useState<any>([]);
  const [modelScreen, setModelScreen] = useState<Boolean>(false);
  const [isInitialLoadScreenWelcome, setIsInitialLoadScreenWelcome] =
    useState<boolean>(false);
  const [questState, setQuestState] = useState<any>({});

  /******************************This for controll backgroud bgm and voice 09.05.2024**********************************/
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
  const backgroundBgmRef = useRef<HTMLAudioElement>(null);
  const voiceRef = useRef<HTMLAudioElement>(null);
  const [audioObj, setAudioObj] = useState<{
    url: string;
    type: string;
    Voicevolume: string;
    BGMvolume: string;
    // volume: string;
    loop: boolean;
    autoplay: boolean;
  }>({
    url: '',
    type: EnumType.BGM,
    Voicevolume: preLogDatasIni?.audioVolumeValue?.voVolume
      ? preLogDatasIni?.audioVolumeValue?.voVolume
      : 0.5,
    BGMvolume: preLogDatasIni?.audioVolumeValue?.bgVolume
      ? preLogDatasIni?.audioVolumeValue?.bgVolume
      : 0.5,

    loop: true, // Background loops
    autoplay: true,
  });
  const [AudioOptions, SetAudioOptions] = useState({ qpOptionId: '' });
  const [score, setScore] = useState(null);
  const [upComingBlockChoosen, setUpComingBlockChoosen] = useState<any>(null);
  const [motionEffect, setMotionEffect] = useState<any>(false);

  const [isCompleteReview, setIsCompleteReview] = useState(false);

  const [CompleteReviewTrue, setCompleteTrue] = useState(false);

  const toast = useToast();

  useEffect(() => {
    setCurrentScreenId(InitialScreenId);
    fetchData();

    reviewid && fetchData();
  }, [InitialScreenId]);

  const userDetails = JSON.parse(localStorage.getItem('user'));

  const fetchData = async () => {
    const ctId = userDetails?.data?.id.toString();

    const result = reviewid
      ? await getImages(1, 'Admin')
      : await getImages(1, ctId);

    if (result?.status !== 'Success')
      return console.warn('getbackruond error:' + result?.message);

    setBackgroundTheme(result?.data);
  };

  const [GlbPlayindDetails, SetGlbPlayingDetails] = useState<{
    audioduration: any;
    characteraction: string;
    whospeak: string;
  }>({
    audioduration: 0,
    characteraction: '',
    whospeak: '',
  });
  const [NonPlayerNameLanguage, setNonPlayerNameLanguage] = useState(
    gameInfo?.gameData?.gameNonPlayerName,
  );
  const [NonPlayerNameLanguageId, setNonPlayerNameLanguageId] = useState(
    gameInfo?.gameData?.gameNonPlayingCharacterId,
  );

  const [PlayerNameLanguage, setPlayerNameLanguage] = useState(
    profileData?.selectedplayer,
  );

  useEffect(() => {
    setPlayerNameLanguage(profileData?.selectedplayer);
  }, [profileData?.selectedplayer]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' || document.hasFocus()) {
        // console.log("The document is hidden")
        if (
          voiceRef.current &&
          !voiceRef.current?.ended &&
          !voiceRef.current?.paused
        ) {
          voiceRef.current.pause();
        }
        if (
          backgroundBgmRef.current &&
          !backgroundBgmRef.current?.ended &&
          !backgroundBgmRef.current?.paused
        ) {
          backgroundBgmRef.current.pause();
        }
      } else if (document.visibilityState === 'visible') {
        if (currentScreenId && currentScreenId !== 10) {
          if (
            voiceRef.current &&
            voiceRef.current?.paused &&
            !voiceRef.current?.ended &&
            currentScreenId === 2 &&
            voiceRef.current?.src !== '' &&
            voiceRef.current?.src !== null &&
            voiceRef.current?.src !== undefined
          ) {
            try {
              voiceRef.current.play().catch((error) => {
                // Handle play promise rejection
              });
            } catch (error) {
              console.error('Background BGM ref is not available.', error);
            }
            // voiceRef.current.play();
          }
          if (
            backgroundBgmRef?.current &&
            backgroundBgmRef?.current?.paused &&
            ![2, 10].includes(currentScreenId) &&
            backgroundBgmRef.current?.src !== '' &&
            backgroundBgmRef.current?.src !== null &&
            backgroundBgmRef.current?.src !== undefined
          ) {
            try {
              backgroundBgmRef.current?.play().catch((error) => {
                // Handle play promise rejection
              });
            } catch (error) {
              console.error('Background BGM ref is not available.', error);
            }
          }
        } else if (
          backgroundBgmRef.current &&
          !backgroundBgmRef.current?.ended &&
          !backgroundBgmRef.current?.paused &&
          currentScreenId !== 2
        ) {
          backgroundBgmRef.current.pause();
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    //2 -story , 10-Intro screen
    if (
      [2, 10].includes(currentScreenId) &&
      backgroundBgmRef.current &&
      !backgroundBgmRef.current?.ended &&
      !backgroundBgmRef.current?.paused
    ) {
      backgroundBgmRef.current.pause();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    /***** End of Handle Audio play when change visibility */
  }, [currentScreenId]);

  useEffect(() => {
    //Initial loading data, it has inital vlaues of preview_logs of the player for this game
    if (preLogDatasIni && Gameid) {
      setPreLogDatas(preLogDatasIni);
      setProfile(preLogDatasIni?.previewScore);
      setQuestState(preLogDatasIni?.questState);
      setProfileData((prev: any) => ({
        ...prev,
        language: preLogDatasIni?.previewProfile?.language,
        name: preLogDatasIni?.previewProfile?.name
          ? preLogDatasIni?.previewProfile?.name
          : profile?.PlayerName ?? '',
        gender: preLogDatasIni?.previewProfile?.gender
          ? preLogDatasIni?.previewProfile?.gender
          : profile?.playerGender ?? '',
      }));
      setAudioObj((prev) => ({
        ...prev,
        Voicevolume: preLogDatasIni?.audioVolumeValue?.voVolume
          ? preLogDatasIni?.audioVolumeValue?.voVolume
          : 0.5,
        BGMvolume: preLogDatasIni?.audioVolumeValue?.bgVolume
          ? preLogDatasIni?.audioVolumeValue?.bgVolume
          : 0.5,
      }));
      setSelectedPlayer(preLogDatasIni?.previewProfile?.selectedPlayer ?? null);
      const { name, gender, language } = preLogDatasIni?.previewProfile ?? {
        name: '',
        gender: '',
        language: '',
      };
      if (!name || !gender || !language) {
        setIsInitialLoadScreenWelcome(true);
      }
    }
  }, [preLogDatasIni]);

  useEffect(() => {
    if (promptType?.name === 'questDelete') {
      const { name, value } = promptType;
      let prevData = Gameid ? { ...getPrevLogDatas } : null;
      const parsedValue = value.toString();
      if (
        prevData !== null &&
        prevData.nevigatedSeq &&
        prevData.nevigatedSeq.hasOwnProperty(parsedValue)
      ) {
        // Remove the key from nevigatedSeq
        const newNevigatedSeq = Object.keys(prevData.nevigatedSeq).filter(
          (key: string) => key !== parsedValue,
        );
        prevData = { ...prevData, nevigatedSeq: { ...newNevigatedSeq } };
      }

      if (
        prevData !== null &&
        prevData?.previewScore &&
        prevData.previewScore.hasOwnProperty('completedLevels')
      ) {
        // Remove the key from previewScore
        const newCompletedLevels =
          prevData?.previewScore?.completedLevels &&
          prevData?.previewScore?.completedLevels.length > 0 &&
          prevData?.previewScore?.completedLevels.filter((element: string) => {
            if (element !== parsedValue) {
              return true;
            }
            return false;
          });
        prevData = {
          ...prevData,
          previewScore: {
            ...prevData.previewScore,
            completedLevels: { ...newCompletedLevels },
          },
        };
      }
      if (
        prevData !== null &&
        prevData?.previewScore &&
        prevData.previewScore.hasOwnProperty('currentQuest')
      ) {
        // Remove the key from nevigatedSeq
        let currentQuest = 1;
        if (parseInt(parsedValue) > 1) {
          const currentQuest = parseInt(parsedValue) - 1;
        }
        prevData = {
          ...prevData,
          previewScore: {
            ...prevData.previewScore,
            currentQuest: currentQuest.toString(),
          },
        };
      }
      if (
        prevData !== null &&
        prevData?.previewScore?.score &&
        prevData.previewScore.score.hasOwnProperty('quest')
      ) {
        // Remove the key from previewScore
        const newScore = prevData.previewScore.score.filter(
          (item: any) => item.quest !== parsedValue,
        );
        prevData = {
          ...prevData,
          previewScore: { ...prevData.previewScore, score: { ...newScore } },
        };
      }
      if (
        prevData !== null &&
        prevData?.previewScore?.replayScore &&
        prevData.previewScore.replayScore.hasOwnProperty('quest')
      ) {
        // Remove the key from previewScore
        const newScore = prevData.previewScore.score.filter(
          (item: any) => item.quest !== parsedValue,
        );
        prevData = {
          ...prevData,
          previewScore: {
            ...prevData.previewScore,
            replayScore: { ...newScore },
          },
        };
      }
      if (
        prevData !== null &&
        prevData &&
        prevData.hasOwnProperty('questState')
      ) {
        // Remove the key from previewScore
        const currenQuestState = { ...prevData?.questState };
        const newQuestState = Object.keys(currenQuestState).filter(
          (key) => key !== parsedValue,
        );
        prevData = { ...prevData, questState: { ...newQuestState } };
      }
      if (
        prevData !== null &&
        prevData &&
        prevData.hasOwnProperty('selectedOptions')
      ) {
        // Remove the key from previewScore
        delete prevData.selectedOptions[parsedValue];
      }
      setNavTrack([]);
      if (prevData !== null) {
        setPreLogDatas({ ...prevData });
      }

      if (currentScreenId === 2 || currentScreenId === 13) {
        if (value == profile.currentQuest) {
          setReplayState(promptType.name);
          setReplayIsOpen(true);
        } else {
          if (gameInfo?.blocks) {
            setDemoBlocks(gameInfo.blocks);
            dispatch(
              updatePreviewData({
                gameId: gameInfo.gameId,
                action: null,
                isModified: false,
              }),
            );
          }
        }
      } else {
        if (gameInfo?.blocks) {
          setDemoBlocks(gameInfo.blocks);
          dispatch(
            updatePreviewData({
              gameId: gameInfo.gameId,
              action: null,
              isModified: false,
            }),
          );
        }
      }
    } else if (promptType?.name === 'blockDelete') {
      let previewData = Gameid ? { ...getPrevLogDatas } : null;
      let newPreviewScore = [];
      const { value, DelseQ, quest } = promptType;
      if (navTrack.length > 0) {
        const Nav = navTrack.filter((item: any) => item !== value);
        setNavTrack(Nav);
      }
      profile.score = profile?.score.filter(
        (item: any) => item.seqId !== value,
      );
      profile.replayScore = profile?.replayScore.filter(
        (item: any) => item.seqId !== value,
      );
      const updatedFeedbackList = feedbackList?.filter(
        (item) => item.Seq !== value,
      );
      setFeedbackList(updatedFeedbackList);
      if (previewData !== null && previewData?.previewScore?.score) {
        const score = [...previewData?.previewScore?.score];
        newPreviewScore = score.filter(
          (item: any) => item.seqId !== promptType.value,
        );
        previewData = {
          ...previewData,
          previewScore: { ...previewData.previewScore, score: newPreviewScore },
        };
      }
      if (previewData !== null && previewData?.previewScore?.replayScore) {
        const score = [...previewData?.previewScore?.replayScore];
        newPreviewScore = score.filter(
          (item: any) => item.seqId !== promptType.value,
        );
        previewData = {
          ...previewData,
          previewScore: {
            ...previewData.previewScore,
            replayScore: newPreviewScore,
          },
        };
      }
      if (
        previewData !== null &&
        previewData.hasOwnProperty('selectedOptions')
      ) {
        let newSelectedOptions = {};
        const { DelseQ, quest } = promptType;
        const inputSeq = DelseQ;
        gameInfo?.blocks &&
          Object.entries(gameInfo?.blocks[quest]).forEach(
            (item: any, index: number) => {
              if (item[1]?.blockSecondaryId === inputSeq) {
                const stringQuestConvert = String(quest);
                const blockIdget = item[1]?.blockId;

                if (item[1]?.blockChoosen === 'Interaction') {
                  const selectedOptions =
                    previewData?.selectedOptions[stringQuestConvert];
                  newSelectedOptions = Array.isArray(selectedOptions)
                    ? selectedOptions.filter(
                        (val: any) => blockIdget !== val.blockId,
                      )
                    : null;
                } else {
                  newSelectedOptions = null;
                }
              }
            },
          );
        if (newSelectedOptions !== null) {
          previewData = {
            ...previewData,
            selectedOptions: {
              ...previewData.selectedOptions,
              [String(quest)]: newSelectedOptions,
            },
          };
        }
      }
      if (
        currentScreenId === 2 &&
        quest == profile.currentQuest &&
        value === data?.blockPrimarySequence
      ) {
        setReplayState('blockDelete');
        setReplayIsOpen(true);
        if (previewData !== null) {
          setPreLogDatas({ ...previewData });
        }
      } else {
        if (gameInfo?.blocks) {
          setDemoBlocks(gameInfo.blocks);
          dispatch(
            updatePreviewData({
              gameId: gameInfo.gameId,
              action: null,
              isModified: false,
            }),
          );
        }
      }
    }
  }, [promptType]);

  useEffect(() => {
    setProfileData((prev: any) => ({ ...prev, score: scoreComp }));
  }, [scoreComp]);

  useEffect(() => {
    const currentDate = new Date();
    // Get day, month, and year
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = currentDate.getFullYear();

    // Format date as DD-MM-YYYY
    const formattedDate = `${day}-${month}-${year}`;

    const scores = profile?.score;
    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      if (score.scoreEarnedDate === formattedDate) {
        sums[quest] += score.score;
      }
    });

    let getFinalscores = {};
    Object.entries(sums).forEach(([quest, score]) => {
      const IntQuest = parseInt(quest);
      const newQuest = { ...getFinalscores, [IntQuest]: score };
      getFinalscores = { ...newQuest };
    });

    const Replayscores =
      profile?.replayScore.length > 0 ? profile?.replayScore : null;
    const Replaysums: { [key: number]: number } = {};
    Replayscores?.forEach((score: any) => {
      const quest = score.quest;
      if (!Replaysums[quest]) {
        Replaysums[quest] = 0;
      }
      if (score.scoreEarnedDate === formattedDate) {
        Replaysums[quest] += score.score;
      }
    });

    let getReplayFinalscores: { [key: number]: number } = {};
    Object.entries(Replaysums).forEach(([quest, score]) => {
      const IntQuest = parseInt(quest);
      getReplayFinalscores = { ...getReplayFinalscores, [IntQuest]: score };
    });
    const TodayTotalScore = Object.entries(getFinalscores).reduce(
      (tot: number, acc: any) => {
        let newTotal = tot;
        let questNo = acc[0];
        let questHasReplay = Object.keys(getReplayFinalscores).some(
          (quest) => quest === questNo,
        );
        if (questHasReplay) {
          getReplayFinalscores[questNo] > acc[1]
            ? (tot += getReplayFinalscores[questNo])
            : (tot += acc[1]);
        } else {
          tot += acc[1];
        }
        return tot;
      },
      0,
    );

    //  scoreEarnedDate: profile?.score.map((item: any) => item.scoreEarnedDate)
    const toDayScore = profile?.score.reduce((total: any, acc: any) => {
      if (acc.scoreEarnedDate === formattedDate) {
        return total + acc.score;
      } else {
        return total;
      }
    }, 0);
    const totalEarnScore = profile?.score.reduce(
      (acc: any, obj: any) => acc + parseInt(obj.score),
      0,
    );
    if (Gameid) {
      setPreLogDatas((prev: any) => ({
        ...prev,
        previewProfile: { ...prev.previewProfile, score: profile.score },
      }));
    }
    setPlayerTodayScore(TodayTotalScore);
  }, [profile?.score]);

  useEffect(() => {
    if (profile && Gameid) {
      setPreLogDatas((prev: any) => ({ ...prev, previewScore: profile }));
    }
  }, [profile]);

  useEffect(() => {
    if (profile?.language) {
      setProfileData((prev: any) => ({ ...prev, language: profile.language }));
    }
  }, [profile?.language]);
  useEffect(() => {
    if (Object.entries(questState).length > 0 && Gameid) {
      setPreLogDatas((prev: any) => ({ ...prev, questState: questState }));
    }
  }, [questState, profile]);
  // This for  Translation content based on lang 09.05.2024
  useEffect(() => {
    const fetchGameContent = async () => {
      const languageId = getPrevLogDatas?.previewProfile?.language
        ? getPrevLogDatas?.previewProfile?.language
        : profileData.language;
      if (getPrevLogDatas?.previewProfile?.language) {
        setProfileData((prev: any) => ({
          ...prev,
          language: getPrevLogDatas?.previewProfile?.language,
        }));
      }
      const gameContentResult = await getContentRelatedLanguage(
        gameInfo?.gameData.gameId,
        languageId,
      );
      if (gameContentResult?.status === 'Success') {
        const data = gameContentResult.data;

        setProfileData((prev: any) => ({
          ...prev,
          Audiogetlanguage: data.map((x: any) => ({
            content: x.content,
            audioUrls: x.audioUrls,
            textId: x.textId,
            fieldName: x.fieldName,
          })),
        }));
      }
    };
    if (profileData.language !== '') {
      fetchGameContent();
    }
  }, [profileData?.language]);

  useEffect(() => {
    setDemoBlocks(gameInfo?.blocks);
    if (data === null && profile.currentQuest) {
      setType(gameInfo?.blocks[profile?.currentQuest]['1']?.blockChoosen);
      setData(gameInfo?.blocks[profile?.currentQuest]['1']);
      if (
        gameInfo?.blocks[profile?.currentQuest]['1']?.blockChoosen ===
        'Interaction'
      ) {
        setRepeatPrevOption([]);
        const optionsFiltered = [];
        const primarySequence =
          gameInfo.blocks[profile.currentQuest]['1'].blockPrimarySequence;

        for (const option of gameInfo.questOptions) {
          if (profileData?.Audiogetlanguage.length > 0) {
            if (option?.qpSequence === primarySequence) {
              const profilesetlan = profileData?.Audiogetlanguage.find(
                (key: any) => key?.textId === option.qpOptionId,
              );

              if (profilesetlan) {
                const languagecont = {
                  ...option,
                  qpOptionText: profilesetlan.content,
                };
                optionsFiltered.push(languagecont);
              } else {
                optionsFiltered.push(option);
              }
            }
          } else {
            if (option?.qpSequence === primarySequence) {
              optionsFiltered.push(option);
            }
          }
        }
        if (gameInfo?.gameData?.gameShuffle === 'true') {
          for (let i = optionsFiltered.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [optionsFiltered[i], optionsFiltered[j]] = [
              optionsFiltered[j],
              optionsFiltered[i],
            ]; // Swap elements at indices i and j
          }
        }
        setOptions(optionsFiltered);
      }
    }
  }, [profile?.currentQuest]);

  useEffect(() => {
    const calculatePlayerGrandTotal = async () => {
      const scores =
        questState[profile?.currentQuest] == 'Started'
          ? profile?.score
          : profile?.replayScore?.length > 0
          ? profile?.replayScore
          : profile?.score;
      let total: number = 0;
      const questScores: any = {};
      if (currentScreenId === 13) {
        //For chapter Selection Screen
        if (profile?.score.length > 0) {
          if (scores?.length > 0) {
            // Calculate scores for each quest
            scores.forEach((score: any) => {
              if (questScores[score.quest]) {
                questScores[score.quest] += score.score;
              } else {
                questScores[score.quest] = score.score;
              }
            });

            setProfile((prev: any) => ({
              ...prev,
              playerGrandTotal: {
                ...prev?.playerGrandTotal,
                questScores,
              },
            }));
          }
        }
      } else if ([2, 4, 6, 8, 9, 14].includes(currentScreenId)) {
        //for story, completion screen, feedback, replay etc.,
        const getscore =
          questState[parseInt(profile?.currentQuest)] !== 'Started' &&
          profile?.replayScore.length > 0
            ? profile?.replayScore
            : profile?.score;

        const scoreArray =
          questState[parseInt(profile?.currentQuest)] == 'Started'
            ? profile?.score
            : getscore;

        if (scoreArray?.length > 0) {
          scores.forEach((score: any) => {
            if (questScores[score.quest]) {
              questScores[score.quest] += score.score;
            } else {
              questScores[score.quest] = score.score;
            }
          });
          setProfile((prev: any) => ({
            ...prev,
            playerGrandTotal: {
              ...prev?.playerGrandTotal,
              questScores,
            },
          }));
        }
      }
      return;
    };

    //Get the Navigated Sequeance to calculate the max score for a Quest
    const calculateQuestGrandTotal = async () => {
      let GrandMaximumscore: any = null;

      const questStatus = questState[profile?.currentQuest];

      if (options) {
        let currentScores;
        const questStatus = questState[profile?.currentQuest];
        if (questStatus === 'completed') {
          // If the quest is completed, compare the scores
          if (profile?.score !== null && profile?.replayScore !== null) {
            currentScores =
              profile.score > profile.replayScore
                ? profile.score
                : profile.replayScore;
          } else {
            console.warn(
              ' *****Invalid score or replayScore provided for completed quest.',
            );
            return; // Exit function if either score or replayScore is not provided for completed quest
          }
        } else if (questStatus === 'Started') {
          // If the quest is started, consider the score
          if (questStatus === 'Started') {
            currentScores =
              profile?.score !== null || profile.score !== undefined
                ? profile.score
                : null; //null or currentScores or replayScore
          } else {
            console.warn(' *****Invalid score provided for started quest.');
            return; // Exit function if score is not provided for started quest
          }
        }
        // Check if currentScores is an array before mapping
        const currentQuestseqId = Array.isArray(currentScores)
          ? currentScores.map((item) => item.seqId)
          : [];

        if (Array.isArray(currentScores) && currentScores.length > 0) {
          // Map currentScores to extract scores
          const scores = currentScores.map((item) => item.score);

          const result = currentQuestseqId.map((seqId) => {
            const QuestNo = seqId.split('.')[0];
            if (QuestNo == profile.currentQuest) {
              const filteredOptions = gameInfo?.questOptions?.filter(
                (option: any) => option.qpSequence == seqId,
              );

              const qpScoresOption = filteredOptions.map((option: any) =>
                parseInt(option.qpScore),
              );
              qpScoresOption.sort((a: any, b: any) => b - a);
              GrandMaximumscore += qpScoresOption[0];
            }
          });
        } else {
          console.warn('*****Options are not provided.');
        }
        setQuestWiseMaxTotal((prev: any) => {
          return { ...prev, [profile?.currentQuest]: GrandMaximumscore };
        });
        return GrandMaximumscore;
      }
    };
    calculateQuestGrandTotal();
    calculatePlayerGrandTotal();
  }, [profile?.score, profile?.replayScore, currentScreenId]);

  useEffect(() => {
    if (
      !gameInfo?.gameData?.gameIntroMusicName &&
      !gameInfo?.gameData?.gameIntroMusic
    ) {
      // fetchDefaultBgMusic();
    } else if (
      gameInfo?.gameData?.gameIntroMusicName &&
      gameInfo?.gameData?.gameIntroMusic
    ) {
      const screens = [1, 11, 12, 13];
      if (
        screens.includes(currentScreenId) &&
        ![2, 3, 4, 5, 6, 7, 10, 0, 15, 14].includes(currentScreenId)
      ) {
        setAudioObj((prev) => ({
          ...prev,
          url: gameInfo?.gameData?.gameIntroMusicName,
          type: EnumType.BGM,
          loop: true, // Voice doesn't loop
          autoplay: true,
        }));
      }
    }
  }, [gameInfo]);

  useEffect(() => {
    if (audio !== '') {
      if (![2, 3, 4, 5, 6, 7, 10, 0, 15, 14].includes(currentScreenId)) {
        setAudioObj((prev) => ({
          ...prev,
          url: audio,
          type: EnumType.BGM,
          loop: true, // Voice doesn't loop
          autoplay: true,
        }));
      }
    }
  }, [audio]);
  const prevTypeRef = useRef<string>();
  /******************Need to handle the audio play and pause */
  // useEffect(() => {
  //   if (voiceRef.current) {
  //     voiceRef.current.pause();
  //   }

  //   const handleAudio = (
  //     audioRef: React.RefObject<HTMLAudioElement>,
  //     audio: any,
  //   ) => {
  //     if (audioRef.current) {
  //       const currentSrc = audioRef.current?.src || '';
  //       if (!currentSrc.endsWith(audio.url) && audio.url) {
  //         audioRef.current.src = audio.url;
  //       }
  //       if (
  //         [2, 15, 14].includes(currentScreenId) &&
  //         document.visibilityState === 'visible'
  //       ) {
  //         audioRef.current.volume = parseFloat(audio.Voicevolume);
  //       } else {
  //         audioRef.current.volume = parseFloat(audio.BGMvolume);
  //       }
  //       audioRef.current.loop = audio.loop;
  //       audioRef.current.autoplay = audio.autoplay;
  //       // Play or pause audio based on the autoplay property
  //       if (audioObj.autoplay) {
  //         if (audioObj.type === EnumType.BGM && backgroundBgmRef.current) {
  //           try {
  //             backgroundBgmRef.current?.play().catch((error) => {
  //               // Handle play promise rejection
  //             });
  //           } catch (error) {
  //             console.error('Background BGM ref is not available.', error);
  //           }
  //         } else if (
  //           audioObj.type === EnumType.VOICE &&
  //           voiceRef.current &&
  //           document.visibilityState === 'visible'
  //         ) {
  //           try {
  //             voiceRef?.current?.play().catch((error) => {
  //               // Handle play promise rejection
  //               console.error('Error playing voice:', error);
  //             });
  //           } catch (error) {
  //             console.error('Error playing voice:', error);
  //           }
  //         }
  //       } else {
  //         if (audioObj.type === EnumType.BGM && backgroundBgmRef.current) {
  //           if (!backgroundBgmRef?.current?.paused) {
  //             backgroundBgmRef?.current?.pause();
  //           }
  //         } else if (audioObj.type === EnumType.VOICE && voiceRef.current) {
  //           if (!voiceRef?.current?.paused) {
  //             voiceRef?.current?.pause();
  //           }
  //         }
  //       }
  //     }
  //   };

  //   if (
  //     audioObj.type === EnumType.BGM &&
  //     document.visibilityState === 'visible'
  //   ) {
  //     handleAudio(backgroundBgmRef, audioObj);
  //   } else if (
  //     audioObj.type === EnumType.VOICE &&
  //     document.visibilityState === 'visible'
  //   ) {
  //     handleAudio(voiceRef, audioObj);
  //   }
  // }, [audioObj, document.visibilityState]);
useEffect(() => {
  const handleAudio = (audioRef: React.RefObject<HTMLAudioElement>, audio: any) => {
    if (!audioRef.current) return;

    // Only update source if it's different
    const currentSrc = audioRef.current.src;
    const isSameSrc = (() => {
      try {
        return new URL(currentSrc).href === new URL(audio.url).href;
      } catch {
        return currentSrc === audio.url;
      }
    })();

    if (!isSameSrc) {
      audioRef.current.src = audio.url;
    }

    // Update volume without stopping playback
    audioRef.current.volume = parseFloat(
      [2, 15, 14].includes(currentScreenId) && document.visibilityState === 'visible'
        ? audio.Voicevolume
        : audio.BGMvolume
    );

    // Handle play/pause only if the autoplay flag changed
    if (audio.autoplay) {
      if (audio.type === EnumType.BGM && backgroundBgmRef.current) {
        if (audioRef.current.paused && ![2, 3, 4, 5, 6, 7, 10, 0, 14].includes(currentScreenId)) {
          audioRef.current.play().catch(console.error);
        }
      } else if (audio.type === EnumType.VOICE && voiceRef.current) {
        if (audioRef.current.paused && document.visibilityState === 'visible' && 
            ![3, 4, 5, 6, 7, 10, 0].includes(currentScreenId)) {
          audioRef.current.play().catch(console.error);
        }
      }
    } else {
      if (!audioRef.current.paused) {
        audioRef.current.pause();
      }
    }
  };

  // Only pause if we're changing audio type (not just volume)
  if (audioObj.type === EnumType.BGM && prevTypeRef.current === EnumType.VOICE) {
    voiceRef.current?.pause();
  } else if (audioObj.type === EnumType.VOICE && prevTypeRef.current === EnumType.BGM) {
    backgroundBgmRef.current?.pause();
  }

  if (document.visibilityState === 'visible') {
    if (audioObj.type === EnumType.BGM) {
      handleAudio(backgroundBgmRef, audioObj);
    } else if (audioObj.type === EnumType.VOICE) {
      handleAudio(voiceRef, audioObj);
    }
  }

  prevTypeRef.current = audioObj.type;
}, [audioObj, document.visibilityState]);

   const handleMusicVolume = (sliderValue: number, type: string) => {
  
    if (!isNaN(sliderValue) && isFinite(sliderValue)) {
      const newVolume = sliderValue / 100;
      if (Gameid) {
        if(type === EnumType.BGM && backgroundBgmRef.current)
        {
           setAudioObj((prev: any) => ({
          ...prev,
          BGMvolume: type === EnumType.BGM ? newVolume.toString() : getPrevLogDatas?.audioVolumeValue?.bgVolume ? getPrevLogDatas?.audioVolumeValue?.bgVolume : 0.5,
        }));
        }
        else if (voiceRef.current) {
           {
           setAudioObj((prev: any) => ({
          ...prev,
          Voicevolume: type === EnumType.VOICE ? newVolume.toString() : getPrevLogDatas?.audioVolumeValue?.voVolume ? getPrevLogDatas?.audioVolumeValue?.voVolume : 0.5,
        }));
        }
        }
       setAudioObj(prev => ({
      ...prev,
      [type === EnumType.BGM ? EnumType.BGM : EnumType.VOICE]: newVolume.toString()
    }));
      }
      else {
         if(type === EnumType.BGM && backgroundBgmRef.current)
        {
  setAudioObj((prev: any) => ({
          ...prev,
          BGMvolume: type === EnumType.BGM ? newVolume.toString() : audioObj?.BGMvolume ? audioObj?.BGMvolume : 0.5,
        }));
        }
         else if (voiceRef.current) { 
  setAudioObj((prev: any) => ({
          ...prev,
          Voicevolume: type === EnumType.VOICE ? newVolume.toString() : audioObj?.Voicevolume ? audioObj?.Voicevolume : 0.5,
        }));
         }
        setAudioObj((prev: any) => ({
          ...prev,
          type: type === EnumType.BGM ? EnumType.BGM : EnumType.VOICE, // Update type based on parameter
        }));
      }

    }
  };
  // Event handler for when the audio playback ends

  useEffect(() => {
    if (gameInfo) {
      setVoiceIds({
        narrator:
          gameInfo?.gameData?.gameNarratorVoice ?? 'D38z5RcWu1voky8WS1ja',
        playerMale:
          gameInfo?.gameData?.gamePlayerMaleVoice ?? '2EiwWnXFnvU5JabPnv8n',
        playerFemale:
          gameInfo?.gameData?.gamePlayerFemaleVoice ?? '21m00Tcm4TlvDq8ikWAM',
        NPC: gameInfo?.gameData?.gameNonPlayerVoice ?? '5Q0t7uMcjvnagumLfvZi',
        Intro: '', //Get the intro music for the game.gameBadge(Primary Key)
      });
    }
  }, [gameInfo?.gameData]);

  useEffect(() => {
    if (![2, 3, 4, 5, 6, 7, 10, 0, 15, 14].includes(currentScreenId)) {
      if (
        !gameInfo?.gameData?.gameIntroMusicName &&
        !gameInfo?.gameData?.gameIntroMusic
      ) {
        // fetchDefaultAudioBgMusic();
        setAudio('');
        setAudioObj((prev) => ({
          ...prev,
          url: '',
          type: EnumType.BGM,
          loop: true, // Voice doesn't loop
          autoplay: true,
        }));
      } else {
        if (
          gameInfo?.gameData?.gameIntroMusicName &&
          gameInfo?.gameData?.gameIntroMusic
        ) {
          setAudio(gameInfo?.gameData?.gameIntroMusicName);
        }
      }
    }
  }, [currentScreenId, gameInfo]);

  // This Function For LastModified Previous
  const findPreviousBlock = (demoBlocks: any, quest: any, currentSeq: any) => {
    if (!currentSeq || !demoBlocks[quest]) return null;

    let [prefix, seq] = currentSeq.split('.').map(Number);

    for (let i = seq - 1; i > 0; i--) {
      const newSeq = `${prefix}.${i}`;
      const prevousBlock = Object.keys(demoBlocks[quest] || {})
        .filter(
          (key) => demoBlocks[quest]?.[key]?.blockPrimarySequence === newSeq,
        )
        .map((key) => demoBlocks[quest]?.[key]);

      if (prevousBlock.length > 0) {
        return prevousBlock; // Return the first match found
      }
    }

    return null; // Return null if no previous sequence is found
  };
  const PreviousBlockNavigation = (
    prevousBlock: any,
    quest: any,
    secondLastSeq: any,
  ) => {
    if (prevousBlock[0]?.blockChoosen === 'Interaction') {
      const selectedBlockIds = Gameid
        ? getPrevLogDatas?.selectedOptions[quest]?.map(
            (option: any) => option.blockId,
          )
        : null;
      const blockId = prevousBlock[0]?.blockId;
      const seqId = prevousBlock[0]?.blockPrimarySequence;
      if (selectedBlockIds !== null && selectedBlockIds?.includes(blockId)) {
        // Remove matching object from profile?.score
        if (questState[quest] === 'Started') {
          profile.score = profile?.score.filter(
            (item: any) => item.seqId !== seqId,
          );
        } else if (questState[quest] === 'replayallowed') {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.seqId !== seqId,
          );
        }
        // Remove matching object from profile?.replayScore
        const updatedFeedbackList = feedbackList?.filter(
          (item) => item.Seq !== seqId,
        );
        setFeedbackList(updatedFeedbackList);
      } else {
        // Remove matching object from profile?.score
        if (Object.keys(questState).length > 0) {
          if (questState[quest] === 'Started') {
            profile.score = profile?.score.filter(
              (item: any) => item.seqId !== seqId,
            );
          } else if (questState[quest] === 'replayallowed') {
            profile.replayScore = profile?.replayScore.filter(
              (item: any) => item.seqId !== seqId,
            );
          } else {
            if (profile?.score.length > 0) {
              profile.score = profile?.score.filter(
                (item: any) => item.seqId !== seqId,
              );
            }
            if (profile?.replayScore.length > 0) {
              profile.replayScore = profile?.replayScore.filter(
                (item: any) => item.seqId !== seqId,
              );
            }
          }
        } else {
          if (profile?.score.length > 0) {
            profile.score = profile?.score.filter(
              (item: any) => item.seqId !== seqId,
            );
          }
          if (profile?.replayScore.length > 0) {
            profile.replayScore = profile?.replayScore.filter(
              (item: any) => item.seqId !== seqId,
            );
          }
        }
        // Remove matching object from profile?.replayScore
        const updatedFeedbackList = feedbackList?.filter(
          (item) => item.Seq !== seqId,
        );
        if (updatedFeedbackList) {
          setFeedbackList(updatedFeedbackList);
        }
      }
    }
    setType(prevousBlock[0]?.blockChoosen);
    setData(prevousBlock[0]);
    if (prevousBlock[0]?.blockChoosen === 'Interaction') {
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (option?.qpSequence === prevousBlock[0]?.blockPrimarySequence) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (option?.qpSequence === prevousBlock[0]?.blockPrimarySequence) {
            optionsFiltered.push(option);
          }
        }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }

      setOptions(optionsFiltered);
    }
    if (Gameid) {
      if (getPrevLogDatas?.nevigatedSeq[prevousBlock[0]?.blockQuestNo]) {
        let updateNavigateSeq: any = [
          ...getPrevLogDatas?.nevigatedSeq[prevousBlock[0]?.blockQuestNo],
        ];
        const lastElementSeq = updateNavigateSeq.pop();
        if (secondLastSeq != updateNavigateSeq[updateNavigateSeq.length - 1]) {
          updateNavigateSeq.push(prevousBlock[0].blockPrimarySequence);
        }
        setPreLogDatas((prev: any) => ({
          ...prev,
          lastBlockModifiedDate: null,
          lastModifiedBlockSeq: null,
          lastActiveBlockSeq: {
            [prevousBlock[0].blockQuestNo]: [prevousBlock[0].blockId],
          },
          nevigatedSeq: {
            ...prev.nevigatedSeq,
            [prevousBlock[0].blockQuestNo]: updateNavigateSeq,
          },
        }));
        return false;
      }
    }
  };
  const UpdateSetPrelogState = (current: any, secondLastSeq: any) => {
    if (Gameid) {
      let updateNavigateSeq: any = [
        ...getPrevLogDatas?.nevigatedSeq[current.blockQuestNo],
      ];
      const lastElementSeq = updateNavigateSeq.pop();
      if (secondLastSeq != updateNavigateSeq[updateNavigateSeq.length - 1]) {
        updateNavigateSeq.push(current.blockPrimarySequence);
      }
      setPreLogDatas((prev: any) => ({
        ...prev,
        lastBlockModifiedDate: null,
        lastModifiedBlockSeq: null,
        lastActiveBlockSeq: { [current.blockQuestNo]: [current.blockId] },
        nevigatedSeq: {
          ...prev.nevigatedSeq,
          [current.blockQuestNo]: updateNavigateSeq,
        },
      }));
      return false;
    }
  };
  const LastModiPrevData = (current: any = null) => {
    const quest = current ? current?.blockPrimarySequence.split('.')[0] : null;
    const lastSeq = Gameid
      ? getPrevLogDatas.nevigatedSeq[current.blockQuestNo]
      : null;
    const secondLastSeq = lastSeq ? lastSeq[lastSeq.length - 2] : null;
    const currentQuest = current
      ? parseInt(current?.blockPrimarySequence.split('.')[0])
      : null;
    setCurrentQuestNo(currentQuest);
    setSelectedOption(null);
    if (type !== 'Interaction') {
      if (type === 'response' && resMsg !== '') {
        setType(current?.blockChoosen);
        setData(current);
        if (current?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }
          setOptions(optionsFiltered);
          return false;
        }
        return false;
      }
      if (type === 'feedback' && feed !== '' && resMsg !== '') {
        setType('response');
        setData(current);
        const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === OptionSelectId,
        );
        if (optionAudioFiltered.length > 0) {
          const responseAudioFiltered = optionAudioFiltered.filter(
            (key: any) => key?.fieldName === 'qpResponse',
          );
          const FilteredResponsecontent = responseAudioFiltered[0].content;
          setResMsg(FilteredResponsecontent);
        } else {
          setResMsg(resMsg);
        }
        return false;
      }
      if (type === 'feedback' && feed !== '' && resMsg === '') {
        setType(current?.blockChoosen);
        setData(current);
        if (current?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }

          setOptions(optionsFiltered);
          return false;
        }
        return false;
      }
    }
    setSelectedOption(null);
    const newTrackSequence = navTrack[navTrack.length - 1];
    const navPrevBlock = current
      ? Object.keys(demoBlocks[quest] || {})
          .filter(
            (key) =>
              demoBlocks[quest]?.[key]?.blockPrimarySequence ===
              newTrackSequence,
          )
          .map((key: any) => demoBlocks[quest]?.[key])
      : [];
    if (navPrevBlock.length > 0) {
      if (navPrevBlock[0].blockSecondaryId === current.blockSecondaryId) {
        navTrack.pop();
        const lastPrevNavTrack = navTrack[navTrack.length - 1];
        if (!lastPrevNavTrack) {
          let getSeqprevious: any = [];
          const getdemoblocksseq: any = Object.entries(demoBlocks[quest]);
          for (const blocks of getdemoblocksseq) {
            const blockId = blocks[1].blockId;
            if (blocks[1].blockLeadTo == current.blockSecondaryId) {
              getSeqprevious.push(blocks[1].blockPrimarySequence);
            }
            for (const optionsnavi of gameInfo.questOptions) {
              if (optionsnavi.qpQuestionId === blockId) {
                if (
                  parseInt(optionsnavi.qpNextOption) ===
                  current.blockSecondaryId
                ) {
                  getSeqprevious.push(blocks[1].blockPrimarySequence);
                }
              }
            }
          }

          if (getSeqprevious.length > 0) {
            getSeqprevious.push(current.blockPrimarySequence);
          }
          getSeqprevious.sort((a: any, b: any) => a - b);
          const currentIndex = getSeqprevious.indexOf(
            current.blockPrimarySequence,
          );
          if (
            current.blockPrimarySequence !==
            gameInfo?.blocks[profile?.currentQuest]['1']?.blockPrimarySequence
          ) {
            if (currentIndex !== -1) {
              if (currentIndex > 0) {
                // Retrieve the previous sequence value
                const previousSeq = getSeqprevious[currentIndex - 1];
                const prevousBlock = current
                  ? Object.keys(demoBlocks[quest] || {})
                      .filter(
                        (key) =>
                          demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                          previousSeq,
                      )
                      .map((key: any) => demoBlocks[quest]?.[key])
                  : [];
                if (prevousBlock.length !== 0) {
                  PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
                } else {
                  UpdateSetPrelogState(current, secondLastSeq);
                }
              } else {
                const checkBlock = getSeqprevious[currentIndex];
                const preblockcheck = checkBlock
                  ? parseInt(checkBlock.split('.')[1])
                  : null;
                const preBlock = preblockcheck ? preblockcheck - 1 : null;
                const previousenaviCheck = preBlock
                  ? `${current?.blockPrimarySequence.split('.')[0]}.${preBlock}`
                  : null;
                let nextSeq: any = null;
                if (
                  previousenaviCheck !==
                  gameInfo?.blocks[profile?.currentQuest]['1']
                    ?.blockPrimarySequence
                ) {
                  nextSeq = getSeqprevious[currentIndex + 1];
                } else {
                  nextSeq = previousenaviCheck;
                }
                // If no previous found, retrieve the next sequence
                const prevousBlock = current
                  ? Object.keys(demoBlocks[quest] || {})
                      .filter(
                        (key) =>
                          demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                          nextSeq,
                      )
                      .map((key: any) => demoBlocks[quest]?.[key])
                  : [];
                if (prevousBlock.length !== 0) {
                  PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
                } else {
                  UpdateSetPrelogState(current, secondLastSeq);
                }
              }
            } else {
              const previousBlockseq = findPreviousBlock(
                demoBlocks,
                quest,
                current?.blockPrimarySequence,
              );
              const prevousBlock = current ? previousBlockseq : [];
              if (prevousBlock.length !== 0) {
                PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
              } else {
                UpdateSetPrelogState(current, secondLastSeq);
              }
            }
          }
        } else {
          const prevousBlock = current
            ? Object.keys(demoBlocks[quest] || {})
                .filter(
                  (key) =>
                    demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                    lastPrevNavTrack,
                )
                .map((key: any) => demoBlocks[quest]?.[key])
            : [];
          if (prevousBlock.length !== 0) {
            PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
          } else {
            UpdateSetPrelogState(current, secondLastSeq);
          }
        }
      } else {
        let getSeqprevious: any = [];
        const getdemoblocksseq: any = Object.entries(demoBlocks[quest]);
        for (const blocks of getdemoblocksseq) {
          const blockId = blocks[1].blockId;
          if (blocks[1].blockLeadTo == current.blockSecondaryId) {
            getSeqprevious.push(blocks[1].blockPrimarySequence);
          }

          for (const optionsnavi of gameInfo.questOptions) {
            if (optionsnavi.qpQuestionId === blockId) {
              if (
                parseInt(optionsnavi.qpNextOption) === current.blockSecondaryId
              ) {
                getSeqprevious.push(blocks[1].blockPrimarySequence);
              }
            }
          }
        }

        if (getSeqprevious.length > 0) {
          getSeqprevious.push(current.blockPrimarySequence);
        }
        getSeqprevious.sort((a: any, b: any) => a - b);
        const currentIndex = getSeqprevious.indexOf(
          current.blockPrimarySequence,
        );
        if (
          current.blockPrimarySequence !==
          gameInfo?.blocks[profile?.currentQuest]['1']?.blockPrimarySequence
        ) {
          if (currentIndex !== -1) {
            if (currentIndex > 0) {
              // Retrieve the previous sequence value
              const previousSeq = getSeqprevious[currentIndex - 1];
              const prevousBlock = current
                ? Object.keys(demoBlocks[quest] || {})
                    .filter(
                      (key) =>
                        demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                        previousSeq,
                    )
                    .map((key: any) => demoBlocks[quest]?.[key])
                : [];
              if (prevousBlock.length !== 0) {
                PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
              } else {
                UpdateSetPrelogState(current, secondLastSeq);
              }
            } else {
              // If no previous found, retrieve the next sequence
              const checkBlock = getSeqprevious[currentIndex];
              const preblockcheck = checkBlock
                ? parseInt(checkBlock.split('.')[1])
                : null;
              const preBlock = preblockcheck ? preblockcheck - 1 : null;
              const previousenaviCheck = preBlock
                ? `${current?.blockPrimarySequence.split('.')[0]}.${preBlock}`
                : null;
              let nextSeq: any = null;
              if (
                previousenaviCheck !==
                gameInfo?.blocks[profile?.currentQuest]['1']
                  ?.blockPrimarySequence
              ) {
                nextSeq = getSeqprevious[currentIndex + 1];
              } else {
                nextSeq = previousenaviCheck;
              }
              const prevousBlock = current
                ? Object.keys(demoBlocks[quest] || {})
                    .filter(
                      (key) =>
                        demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                        nextSeq,
                    )
                    .map((key: any) => demoBlocks[quest]?.[key])
                : [];
              if (prevousBlock.length !== 0) {
                PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
              } else {
                UpdateSetPrelogState(current, secondLastSeq);
              }
            }
          } else {
            const previousBlockseq = findPreviousBlock(
              demoBlocks,
              quest,
              current?.blockPrimarySequence,
            );
            const prevousBlock = current ? previousBlockseq : [];
            if (prevousBlock.length !== 0) {
              PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
            } else {
              UpdateSetPrelogState(current, secondLastSeq);
            }
          }
        }
      }
    } else {
      let getSeqprevious: any = [];
      const getdemoblocksseq: any = Object.entries(demoBlocks[quest]);
      for (const blocks of getdemoblocksseq) {
        const blockId = blocks[1].blockId;
        if (blocks[1].blockLeadTo == current.blockSecondaryId) {
          getSeqprevious.push(blocks[1].blockPrimarySequence);
        }

        for (const optionsnavi of gameInfo.questOptions) {
          if (optionsnavi.qpQuestionId === blockId) {
            if (
              parseInt(optionsnavi.qpNextOption) === current.blockSecondaryId
            ) {
              getSeqprevious.push(blocks[1].blockPrimarySequence);
            }
          }
        }
      }

      if (getSeqprevious.length > 0) {
        getSeqprevious.push(current.blockPrimarySequence);
      }
      getSeqprevious.sort((a: any, b: any) => a - b);
      const currentIndex = getSeqprevious.indexOf(current.blockPrimarySequence);
      if (
        current.blockPrimarySequence !==
        gameInfo?.blocks[profile?.currentQuest]['1']?.blockPrimarySequence
      ) {
        if (currentIndex !== -1) {
          if (currentIndex > 0) {
            // Retrieve the previous sequence value
            const previousSeq = getSeqprevious[currentIndex - 1];
            const prevousBlock = current
              ? Object.keys(demoBlocks[quest] || {})
                  .filter(
                    (key) =>
                      demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                      previousSeq,
                  )
                  .map((key: any) => demoBlocks[quest]?.[key])
              : [];
            if (prevousBlock.length !== 0) {
              PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
            } else {
              UpdateSetPrelogState(current, secondLastSeq);
            }
          } else {
            // If no previous found, retrieve the next sequence
            const checkBlock = getSeqprevious[currentIndex];
            const preblockcheck = checkBlock
              ? parseInt(checkBlock.split('.')[1])
              : null;
            const preBlock = preblockcheck ? preblockcheck - 1 : null;
            const previousenaviCheck = preBlock
              ? `${current?.blockPrimarySequence.split('.')[0]}.${preBlock}`
              : null;
            let nextSeq: any = null;
            if (
              previousenaviCheck !==
              gameInfo?.blocks[profile?.currentQuest]['1']?.blockPrimarySequence
            ) {
              nextSeq = getSeqprevious[currentIndex + 1];
            } else {
              nextSeq = previousenaviCheck;
            }
            const prevousBlock = current
              ? Object.keys(demoBlocks[quest] || {})
                  .filter(
                    (key) =>
                      demoBlocks[quest]?.[key]?.blockPrimarySequence ===
                      nextSeq,
                  )
                  .map((key: any) => demoBlocks[quest]?.[key])
              : [];
            if (prevousBlock.length !== 0) {
              PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
            } else {
              UpdateSetPrelogState(current, secondLastSeq);
            }
          }
        } else {
          const previousBlockseq = findPreviousBlock(
            demoBlocks,
            quest,
            current?.blockPrimarySequence,
          );
          const prevousBlock = current ? previousBlockseq : [];
          if (prevousBlock.length !== 0) {
            PreviousBlockNavigation(prevousBlock, quest, secondLastSeq);
          } else {
            UpdateSetPrelogState(current, secondLastSeq);
          }
        }
      }
    }
  };
  const calcQuestGrandTotal = async (
    scores: any,
    currentQuestNo: any = null,
  ) => {
    if (scores?.length <= 0) {
      return 0;
    }

    if (currentQuestNo != null) {
      // Sum score of a quest
      const totalScore = scores.reduce((total: number, sc: any) => {
        if (sc.quest == currentQuestNo) {
          return total + sc.score;
        } else {
          return total;
        }
      }, 0);
      return totalScore; // Return the total score
    } else {
      //Sum up all the scores
      return scores.reduce((total: number, sc: any) => total + sc.score, 0);
    }
  };

  const checkAndUpdateScores = async () => {
    const currentQuest = profile.currentQuest;
    // if (questState[currentQuest] !== 'Started') {
    const scoreTotal = await calcQuestGrandTotal(
      profile.score,
      profile.currentQuest,
    );
    const replayScoreTotal = await calcQuestGrandTotal(
      profile.replayScore,
      profile.currentQuest,
    );

    if (scoreTotal <= replayScoreTotal) {
      const currentQuestRemovedScoreArr = profile.score.filter(
        (item: any) => item.quest != profile.currentQuest,
      );
      let concatenatedScoreArr: any[] = [];
      if (profile.replayScore.length > 0) {
        concatenatedScoreArr = profile.replayScore.filter(
          (item: any) => item.quest == profile.currentQuest,
        );
      }
      if (currentQuestRemovedScoreArr.length > 0) {
        concatenatedScoreArr = [
          ...concatenatedScoreArr,
          ...currentQuestRemovedScoreArr,
        ];
      }
      const currentQuestRemovedReplayScoreArr = profile.replayScore.filter(
        (item: any) => item.quest != profile.currentQuest,
      );

      setProfile((prev: any) => ({
        ...prev,
        score: concatenatedScoreArr,
        replayScore: currentQuestRemovedReplayScoreArr,
      }));
    } else {
      const currentQuestRemovedReplayScoreArr = profile.replayScore.filter(
        (item: any) => item.quest != profile.currentQuest,
      );
      setProfile((prev: any) => ({
        ...prev,
        replayScore: currentQuestRemovedReplayScoreArr,
      }));
    }
  };

  const setInteractionOptions = (gameInfo: any, currentBlock: any) => {
    const optionsFiltered = [];
    for (const option of gameInfo.questOptions) {
      if (profileData?.Audiogetlanguage.length > 0) {
        if (option?.qpSequence === currentBlock?.blockPrimarySequence) {
          const profilesetlan = profileData?.Audiogetlanguage.find(
            (key: any) => key?.textId === option.qpOptionId,
          );

          if (profilesetlan) {
            const languagecont = {
              ...option,
              qpOptionText: profilesetlan.content,
            };
            optionsFiltered.push(languagecont);
          } else {
            optionsFiltered.push(option);
          }
        }
      } else {
        if (option?.qpSequence === currentBlock?.blockPrimarySequence) {
          optionsFiltered.push(option);
        }
      }
    }

    if (gameInfo?.gameData?.gameShuffle === 'true') {
      for (let i = optionsFiltered.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [optionsFiltered[i], optionsFiltered[j]] = [
          optionsFiltered[j],
          optionsFiltered[i],
        ];
      }
      setOptions(optionsFiltered);
    }
  };
  const getData = (next: any) => {
    if (navi === '' || navi !== 'Repeat Question') {
      setRepeatPrevOption([]);
    }
    setRepeatSelectOption(false);
    setIsPrevNavigation(false);
    if (
      next?.blockChoosen === 'Interaction' &&
      gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
    ) {
      const isDuplicate = feedbackList?.some(
        (item: any) =>
          item.Seq === next?.blockPrimarySequence &&
          item.Options === getSelectedOptions,
      );

      if (!isDuplicate) {
        if (feed !== '') {
          setFeedbackList((prevFeedbackList) => [
            ...prevFeedbackList,
            {
              quest: next?.blockQuestNo,
              feedbackcontent: feed,
              type: navi,
              Seq: next?.blockPrimarySequence,
              Options: getSelectedOptions,
              totalPoints: playerTodayScore,
            },
          ]);
        }
      }
    }

    if (Gameid) {
      SetPreviouseStored(next);
    }
    const currentBlock = next
      ? parseInt(next?.blockPrimarySequence.split('.')[1])
      : null;
    const quest = next ? next?.blockPrimarySequence.split('.')[0] : null;
    const valuesArray =
      demoBlocks && demoBlocks[quest] ? Object.values(demoBlocks[quest]) : null;
    const currentIndex = valuesArray
      ? valuesArray?.findIndex(
          (item: any) =>
            item.blockPrimarySequence === next?.blockPrimarySequence,
        )
      : 0;
    let NextSeqBlock: any;
    if (currentIndex > 0) {
      NextSeqBlock = valuesArray[currentIndex + 1];
    } else {
      NextSeqBlock = null; // No previous sequence
    }
    const NextItem =
      NextSeqBlock != null
        ? parseInt(NextSeqBlock?.blockPrimarySequence.split('.')[1])
        : null;
    const nextSeq = next
      ? `${next?.blockPrimarySequence.split('.')[0]}.${NextItem}`
      : '';
    const prevTrack = navTrack;

    const currentQuest = next
      ? parseInt(next?.blockPrimarySequence.split('.')[0])
      : null;
    setCurrentQuestNo(currentQuest);
    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    const nextBlock = next
      ? Object.keys(demoBlocks[quest] || {})
          .filter(
            (key) => demoBlocks[quest]?.[key]?.blockPrimarySequence === nextSeq,
          )
          .map((key: any) => demoBlocks[quest]?.[key])
      : [];
    if (currentScreenId === 2) {
      const currentDataOfBlocks = Object.values(
        demoBlocks[next?.blockQuestNo],
      ).filter(
        (item: any) =>
          item?.blockPrimarySequence === nextBlock[0]?.blockPrimarySequence,
      );

      for (let key in demoBlocks[next?.blockQuestNo]) {
        if (demoBlocks[next?.blockQuestNo].hasOwnProperty(key)) {
          const block = demoBlocks[next?.blockQuestNo][key];
          const isMatchingBlock = currentDataOfBlocks.some(
            (currentBlock) =>
              JSON.stringify(currentBlock) === JSON.stringify(block),
          );
          if (isMatchingBlock) {
            const convertToNum = Number(key);
            const incrementValue = Math.round(convertToNum + 1);
            const aHeadOfData =
              demoBlocks[next?.blockQuestNo][incrementValue]?.blockChoosen;
            setUpComingBlockChoosen(aHeadOfData);
          }
        }
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      if (!conditionTypes.includes(type)) {
        setFeed('');
        if (next?.blockShowNavigate) {
          if (next?.blockShowNavigate === 'Repeat Question') {
            const currentBlockinteraction =
              gameInfo?.blocks[currentQuest][currentBlock];
            setInteractionOptions(gameInfo, currentBlockinteraction);
            setType(next?.blockChoosen);
            setData(next);
            setSelectedOption(null);
            return false;
          } else if (next?.blockShowNavigate === 'New Block') {
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(next?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];

                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              setSelectedOption(null);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                setSelectedOption(null);
                return false;
              } else {
                setReplayState('noNavigation');
                setReplayIsOpen(true);
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setSelectedOption(null);
                return false;
              }
            }
          } else if (next?.blockShowNavigate === 'Replay Point') {
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          } else if (next?.blockShowNavigate === 'Select Block') {
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(next?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];

                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              setSelectedOption(null);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                setSelectedOption(null);
                return false;
              } else {
                setReplayState('noNavigation');
                setReplayIsOpen(true);
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setSelectedOption(null);
                return false;
              }
            }
          } else if (next?.blockShowNavigate === 'Complete') {
            setSelectedOption(null);
            //check the replay Quest score is higher than score in profile context
            checkAndUpdateScores();
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            } else {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                return data;
              });
            }
            setCurrentScreenId(6);
            setType(null);
            setData(null);
            return false;
          } else {
            setReplayState('noNavigation');
            setReplayIsOpen(true);

            setType(demoBlocks[quest]['1']?.blockChoosen);
            setData(demoBlocks[quest]['1']);
            if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1']?.blockPrimarySequence
                  ) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1'].blockPrimarySequence
                  ) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            setSelectedOption(null);
            return false;
          }
        } else {
          setReplayState('noNavigation');
          setReplayIsOpen(true);
          setType(demoBlocks[quest]['1']?.blockChoosen);
          setData(demoBlocks[quest]['1']);
          if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
            const optionsFiltered = [];
            for (const option of gameInfo.questOptions) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (
                  option?.qpSequence ===
                  demoBlocks[quest]['1']?.blockPrimarySequence
                ) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );

                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (
                  option?.qpSequence ===
                  demoBlocks[quest]['1'].blockPrimarySequence
                ) {
                  optionsFiltered.push(option);
                }
              }
            }
            if (gameInfo?.gameData?.gameShuffle === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ];
              }
            }
            setOptions(optionsFiltered);
          }
          setSelectedOption(null);
          return false;
        }
      } else {
        // if (nextBlock[0]?.blockChoosen === 'Interaction') {
        //   const optionsFiltered = [];
        //   for (const option of gameInfo.questOptions) {
        //     if (profileData?.Audiogetlanguage.length > 0) {
        //       if (option?.qpSequence === nextBlock[0]?.blockPrimarySequence) {
        //         const profilesetlan = profileData?.Audiogetlanguage.find(
        //           (key: any) => key?.textId === option.qpOptionId,
        //         );
        //         if (profilesetlan) {
        //           const languagecont = {
        //             ...option,
        //             qpOptionText: profilesetlan.content,
        //           };
        //           optionsFiltered.push(languagecont);
        //         } else {
        //           optionsFiltered.push(option);
        //         }
        //       }
        //     } else {
        //       if (option?.qpSequence === nextBlock[0]?.blockPrimarySequence) {
        //         optionsFiltered.push(option);
        //       }
        //     }
        //   }
        //   if (gameInfo?.gameData?.gameShuffle === 'true') {
        //     for (let i = optionsFiltered.length - 1; i > 0; i--) {
        //       const j = Math.floor(Math.random() * (i + 1));
        //       [optionsFiltered[i], optionsFiltered[j]] = [
        //         optionsFiltered[j],
        //         optionsFiltered[i],
        //       ];
        //     }
        //   }
        //   setOptions(optionsFiltered);
        // }
        if (type === 'Interaction' && resMsg !== '') {
          setType('response');
          return false;
        } else if (
          (type === 'Interaction' || type === 'response') &&
          feed !== '' &&
          gameInfo?.gameData?.gameIsShowInteractionFeedBack !== 'Completion'
        ) {
          if (navi === 'Replay Point') {
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          } else {
            setType('feedback');
            return false;
          }
        } else if (
          type === 'Interaction' ||
          type === 'response' ||
          type === 'feedback'
        ) {
          if (navi === 'Repeat Question') {
            setFeed('');
            setRepeatSelectOption(true);
            RepeatPrevOption.push(getSelectedOptions.options);
            setRepeatPrevOption(RepeatPrevOption);
            setType(next?.blockChoosen);
            setData(next);
            if (next?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (option?.qpSequence === next?.blockPrimarySequence) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );
                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (option?.qpSequence === next?.blockPrimarySequence) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            setSelectedOption(null);
            return false;
          } else if (navi === 'New Block') {
            setFeed('');
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(optionNavigation)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              setSelectedOption(null);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                setSelectedOption(null);
                return false;
              } else {
                setReplayState('noNavigation');
                setReplayIsOpen(true);
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setSelectedOption(null);
                return false;
              }
            }
          } else if (navi === 'Replay Point') {
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          } else if (navi === 'Select Block') {
            setFeed('');
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(optionNavigation)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              setSelectedOption(null);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                setSelectedOption(null);
                return false;
              } else {
                setReplayState('noNavigation');
                setReplayIsOpen(true);
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setSelectedOption(null);
                return false;
              }
            }
          } else if (navi === 'Complete') {
            setFeed('');
            setSelectedOption(null);

            checkAndUpdateScores();
            const Nextcurrentquest = next?.blockQuestNo;
            const getgameinfoquest = gameInfo?.gameQuest.find(
              (row: any) => row.gameQuestNo == Nextcurrentquest,
            );
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            } else {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                return data;
              });
            }
            setCurrentScreenId(6);
            setType(null);
            setData(null);
            return false;
          } else {
            setFeed('');
            setReplayState('noNavigation');
            setReplayIsOpen(true);
            setType(demoBlocks[quest]['1']?.blockChoosen);
            setData(demoBlocks[quest]['1']);
            if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1']?.blockPrimarySequence
                  ) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1'].blockPrimarySequence
                  ) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            setSelectedOption(null);
            return false;
          }
        }
      }
    }
    if (currentScreenId === 6) {
      //Completion
      const {
        currentQuest,
        currentGameData,
        nextLevel,
        haveNextQuest,
        totalScore,
      } = calScore();
      if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
        setCurrentScreenId(4); //Navigate to leaderboard
        return false;
      } else {
        checkAndUpdateScores();
        (async () => {
          const finalscore = await getPlayerFinalScore(
            profile?.score,
            currentGameData,
          );

          const isMandatoryReplayPromptRequired =
            await checkIsMandatoryReplayPromptRequired(
              Number(finalscore),
              currentGameData,
            );

          if (isMandatoryReplayPromptRequired) {
            Setprofilescore(finalscore);
            setReplayState('mandatoryReplay');
            setReplayIsOpen(true);
            return;
          }
          const isOptionalReplayAllowed = await isOptionalReplayAllow(
            Number(finalscore),
            currentGameData,
            gameInfo.gameData?.gameDisableOptionalReplays,
          );

          if (
            feedbackList.length !== 0 &&
            gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
          ) {
            const Completionpage = Object.entries(questState).map(
              ([questId, status]) => ({ questId, status }),
            );
            const OpenStraigntCompletionPage = Completionpage.find(
              (row: any) =>
                row.questId === profile.currentQuest &&
                row.status === 'completed',
            );

            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            }

            if (
              feedbackList.length !== 0 &&
              feedbackList?.find(
                (item: any) => item.quest == profile.currentQuest,
              )
            ) {
              getFeedbackData(next);
              setFeedbackNavigateNext(false);
              setCurrentScreenId(14); //Navigate to together all feedback
              return false;
            } else {
              if (demoBlocks.hasOwnProperty(nextLevel)) {
                setProfile((prev: any) => {
                  const data = { ...prev };
                  if (!profile.completedLevels.includes(String(nextLevel))) {
                    data.completedLevels = [
                      ...data.completedLevels,
                      String(nextLevel),
                    ];
                  }
                  return data;
                });

                setType(demoBlocks[nextLevel]['1']?.blockChoosen);
                setData(demoBlocks[nextLevel]['1']);
                setMotionEffect(true);
                setCurrentScreenId(13);
                return false;
              } else {
                if (gameInfo.gameData?.gameIsShowReflectionScreen === 'true') {
                  setCurrentScreenId(3); //Navigate to Reflection screen
                  return false;
                } else if (gameInfo.gameData?.gameIsShowTakeaway === 'true') {
                  setCurrentScreenId(7); //Navigate to takeaway screen
                  return false;
                } else {
                  setType(null);
                  setData(null);
                  setCurrentScreenId(5);
                  return false;
                }
              }
            }
          } else if (isMandatoryReplayPromptRequired) {
            Setprofilescore(finalscore);
            setReplayState('mandatoryReplay');
          } else if (isOptionalReplayAllowed) {
            setReplayState('optionalReplay');
            setReplayIsOpen(true);
            return;
          } else if (demoBlocks.hasOwnProperty(nextLevel)) {
            setProfile((prev: any) => {
              const data = { ...prev };
              if (!profile.completedLevels.includes(String(nextLevel))) {
                data.completedLevels = [
                  ...data.completedLevels,
                  String(nextLevel),
                ];
              }
              return data;
            });
            setType(demoBlocks[nextLevel]['1']?.blockChoosen);
            setData(demoBlocks[nextLevel]['1']);
            setMotionEffect(true);
            setCurrentScreenId(13);
            return false;
          } else if (
            gameInfo?.gameData?.gameIsShowReflectionScreen === 'true'
          ) {
            setCurrentScreenId(3); //reflection screen
            return false;
          } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
            setCurrentScreenId(7); //takeaway
            return false;
          } else if (isMandatoryReplayPromptRequired) {
            Setprofilescore(finalscore);
            setReplayState('mandatoryReplay');
            setReplayIsOpen(true);
            return false;
          } else {
            setType(null);
            setData(null);
            setCurrentScreenId(5); //thank you screen
            return false;
          }
        })();
      }
    }
    if (currentScreenId === 14) {
      const Nextcurrentquest = profile?.currentQuest;
      const getgameinfoquest = gameInfo?.gameQuest.find(
        (row: any) => row.gameQuestNo == Nextcurrentquest,
      );
      const { currentGameData } = calScore();

      (async () => {
        const finalscore = await getPlayerFinalScore(
          profile?.score,
          currentGameData,
        );

        const isMandatoryReplayPromptRequired =
          await checkIsMandatoryReplayPromptRequired(
            Number(finalscore),
            currentGameData,
          );

        const isOptionalReplayAllowed = await isOptionalReplayAllow(
          Number(finalscore),
          currentGameData,
          gameInfo.gameData?.gameDisableOptionalReplays,
        );
        if (isMandatoryReplayPromptRequired) {
          Setprofilescore(finalscore);
          setReplayState('mandatoryReplay');
          setReplayIsOpen(true);
          return;
        } else if (isOptionalReplayAllowed) {
          setReplayState('optionalReplay');
          setReplayIsOpen(true);
          return;
        } else if (demoBlocks.hasOwnProperty(nextLevel)) {
          setProfile((prev: any) => {
            const data = { ...prev };
            if (!profile.completedLevels.includes(String(nextLevel))) {
              data.completedLevels = [
                ...data.completedLevels,
                String(nextLevel),
              ];
            }
            return data;
          });

          setType(demoBlocks[nextLevel]['1']?.blockChoosen);
          setData(demoBlocks[nextLevel]['1']);
          setMotionEffect(true);
          setCurrentScreenId(13);
          return false;
        } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
          setCurrentScreenId(3); //reflection screen
          return false;
        } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
          setCurrentScreenId(7); //takeaway
          return false;
        } else {
          setType(null);
          setData(null);
          setCurrentScreenId(5); //thank you screen
          return false;
        }
      })();
    }

    if (currentScreenId === 8) {
      if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
        setCurrentScreenId(4);
        return false;
      } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
        setCurrentScreenId(3);
        return false;
      } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
        setCurrentScreenId(7);
        return false;
      } else {
        if (data && type) {
          setCurrentScreenId(2);
          return false;
        } else {
          setType(null);
          setData(null);

          setCurrentScreenId(5);
          return false;
        }
      }
    }
    /**4  - Leaderboard */
    if (currentScreenId === 4) {
      checkAndUpdateScores();

      const Nextcurrentquest = profile?.currentQuest;
      const getgameinfoquest = gameInfo?.gameQuest.find(
        (row: any) => row.gameQuestNo == Nextcurrentquest,
      );
      (async () => {
        const finalscore = await getPlayerFinalScore(
          profile?.score,
          getgameinfoquest,
        );

        const isMandatoryReplayPromptRequired =
          await checkIsMandatoryReplayPromptRequired(
            Number(finalscore),
            getgameinfoquest,
          );

        const isOptionalReplayAllowed = await isOptionalReplayAllow(
          Number(finalscore),
          getgameinfoquest,
          gameInfo.gameData?.gameDisableOptionalReplays,
        );
        if (
          gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
        ) {
          const Completionpage = Object.entries(questState).map(
            ([questId, status]) => ({ questId, status }),
          );

          if (
            feedbackList.length !== 0 &&
            feedbackList?.find(
              (item: any) => item.quest == profile.currentQuest,
            )
          ) {
            getFeedbackData(data);
            setFeedbackNavigateNext(false);
            setCurrentScreenId(14); //Navigate to together all feedback
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            }
            return false;
          } else if (isMandatoryReplayPromptRequired) {
            Setprofilescore(finalscore);
            setReplayState('mandatoryReplay');
            setReplayIsOpen(true);
            return;
          } else if (isOptionalReplayAllowed) {
            setReplayState('optionalReplay');
            setReplayIsOpen(true);
            return;
          } else {
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setFeedbackNavigateNext(false);
              setProfile((prev: any) => {
                const data = { ...prev };
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });

              setType(demoBlocks[nextLevel]['1']?.blockChoosen);
              setData(demoBlocks[nextLevel]['1']);
              setMotionEffect(true);
              setCurrentScreenId(13);
              return false;
            } else if (
              gameInfo?.gameData?.gameIsShowReflectionScreen === 'true'
            ) {
              setCurrentScreenId(3);
              return false;
            } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
              setCurrentScreenId(7);
              return false;
            } else {
              setType(null);
              setData(null);
              setCurrentScreenId(5);
              return false;
            }
          }
        } else if (isMandatoryReplayPromptRequired) {
          Setprofilescore(finalscore);
          setReplayState('mandatoryReplay');
          setReplayIsOpen(true);
          return;
        } else if (isOptionalReplayAllowed) {
          setReplayState('optionalReplay');
          setReplayIsOpen(true);
          return;
        } else if (demoBlocks.hasOwnProperty(nextLevel)) {
          setFeedbackNavigateNext(false);
          setProfile((prev: any) => {
            const data = { ...prev };
            if (!profile.completedLevels.includes(String(nextLevel))) {
              data.completedLevels = [
                ...data.completedLevels,
                String(nextLevel),
              ];
            }
            return data;
          });
          setType(demoBlocks[nextLevel]['1']?.blockChoosen);
          setData(demoBlocks[nextLevel]['1']);
          setMotionEffect(true);
          setCurrentScreenId(13);
          return false;
        } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
          setCurrentScreenId(3);

          return false;
        } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
          setCurrentScreenId(7);
          return false;
        } else {
          setType(null);
          setData(null);
          setCurrentScreenId(5);
          return false;
        }
      })();
      //}
    }
    if (currentScreenId === 7) {
      setCurrentScreenId(5);
      return false;
    }
  };

  const calScore = () => {
    const currentQuest = profile?.currentQuest || '1';
    const currentGameData = gameInfo.gameQuest.find(
      (row: any) => row.gameQuestNo == profile?.currentQuest,
    );

    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    const haveNextQuest = gameInfo.gameQuest.some(
      (row: any) => row.gameQuestNo > profile.currentQuest,
    );
    let totalScore = 0;
    const ifPlayInProgress =
      profile?.replayScore?.length > 0 &&
      profile?.replayScore?.some(
        (item: any) => item.quest === profile?.currentQuest,
      );
    if (ifPlayInProgress) {
      totalScore = profile?.replayScore.reduce((acc: any, row: any) => {
        if (row.quest === profile?.currentQuest) {
          return acc + row.score;
        }
        return acc;
      }, 0);
    } else {
      profile?.score.reduce((acc: any, row: any) => {
        if (row.quest === profile?.currentQuest) {
          return acc + row.score;
        }
        return acc;
      }, 0);
    }
    return {
      currentQuest: currentQuest,
      currentGameData: currentGameData,
      nextLevel: nextLevel,
      haveNextQuest: haveNextQuest,
      totalScore: totalScore,
    };
  };

  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  // validate the choosed option
  const handleValidate = (item: any, ind: number) => {
    setCurrentScore(parseInt(item?.qpScore));
    const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
      (key: any) => key?.textId === item?.qpOptionId,
    );
    if (optionAudioFiltered.length > 0) {
      const responseFiltered = optionAudioFiltered.filter(
        (key: any) => key?.fieldName === 'qpResponse',
      );
      const FeedFiltered = optionAudioFiltered.filter(
        (key: any) => key?.fieldName === 'qpFeedback',
      );
      if (responseFiltered.length > 0) {
        const FilteredResponsecontent = responseFiltered[0]?.content;
        const resMsgLanguage = FilteredResponsecontent;
        setResMsg(resMsgLanguage);
      } else {
        setResMsg(item?.qpResponse);
      }
      if (FeedFiltered.length > 0) {
        const FilteredFeedcontent = FeedFiltered[0]?.content;
        const feedMsgLanguage = FilteredFeedcontent;
        setFeed(feedMsgLanguage);
      } else {
        setFeed(item?.qpFeedback);
      }
    } else {
      setResMsg(item?.qpResponse);
      setFeed(item?.qpFeedback);
    }

    setNavi(item?.qpNavigateShow);
    setOptionNavigation(item?.qpNextOption);
    setSelectedOption(ind === selectedOption ? null : ind);
    const text = '..Option ' + item.qpOptions + ' -- ' + item.qpOptionText;
    SetgetSelectedOptions({
      options: item.qpOptions,
      optionText: item.qpOptionText,
    });
    setOptionSelectId(item.qpOptionId);
    const voiceId =
      profileData?.gender === 'Male'
        ? voiceIds?.playerMale
        : voiceIds?.playerFemale;
  };

  useEffect(() => {
    if (voiceRef.current) {
      voiceRef.current.pause();
    }
    const backGroundBgmscreens = [1, 11, 12, 13, 15];

    if (
      ![2, 3, 4, 5, 6, 7, 10, 0, 15, 14].includes(currentScreenId) &&
      backGroundBgmscreens.includes(currentScreenId)
    ) {
      if (audioObj.url !== audio) {
        setAudioObj((prev) => ({
          ...prev,
          url: audio,
          type: EnumType.BGM,
          loop: true,
          autoplay: true,
        }));
      }
      if (backgroundBgmRef.current) {
        try {
          backgroundBgmRef.current.play().catch((error) => {}); // Play background BGM
        } catch (error) {
          console.error('Background BGM ref is not available.', error);
        }
      }
      if (voiceRef.current) {
        voiceRef.current.pause(); // Pause voice
      }
    }
    if (currentScreenId === 2 && isLoading === true) {
      if (backgroundBgmRef.current) {
        backgroundBgmRef.current.pause(); // pause background BGM
      }
      if (voiceRef.current) {
        try {
          voiceRef?.current?.play().catch((error) => {}); // Play background BGM
        } catch (error) {
          console.error('Background BGM ref is not available.', error);
        }
      }
    }
    setFeedBackFromValue();
    const screens = [10, 8, 14, 9, 15, 16, 0, 6, 4];
    if (!screens.includes(currentScreenId) && Gameid) {
      setPreLogDatas((prev: any) => ({
        ...prev,
        screenIdSeq: [currentScreenId],
      }));
    }
    if (currentScreenId === 15) {
      setHomeLeaderBoard(2);
    } else {
      if (currentScreenId !== 4) {
        setHomeLeaderBoard(null);
      }
    }
  }, [currentScreenId]);

  const setFeedBackFromValue = () => {
    switch (currentScreenId) {
      case 0:
        setReviewTabOptions([1, 5]); //GameInto screen
        break;
      case 1:
        // setReviewTabOptions([1, 3, 5]); //Welcome
        setReviewTabOptions([5]); //Welcome
        break;
      case 2:
        setReviewTabOptions([1, 2, 4]); //Story
        break;
      case 3:
        setReviewTabOptions([5]); //Reflection
        break;
      case 4:
        setReviewTabOptions([5]); //Leaderboard
        break;
      case 5:
        setReviewTabOptions([5]); //ThanksScreen
        break;
      case 6:
        setReviewTabOptions([5]); //Completion
        break;
      case 7:
        setReviewTabOptions([5]); //TakeAway
        break;
      case 9:
        setReviewTabOptions([1, 2, 4]); //Feedback after Each interaction
        break;
      case 14:
        setReviewTabOptions([1, 2, 4]); //Feedback after Completion All together
        break;
    }
  };

  useEffect(() => {
    if (reviewTabOptions) {
      const filterTabOptionsList = tabOptions.filter((tabOption) =>
        reviewTabOptions.includes(tabOption.value),
      );

      setFilteredTabOptions(filterTabOptionsList);
    }
  }, [reviewTabOptions]);

  const subTabOptionsForTabIds: Array<{
    [key: string]: Array<{ value: string; label: string }> | null;
  }> = [
    { '1': null },
    { '2': null },
    {
      '3': [
        { value: 'Title', label: 'Title' },
        { value: 'Skill', label: 'Skill' },
        { value: 'Storyline', label: 'Storyline' },
        { value: 'Outcomes', label: 'Outcomes' },
        { value: 'Category', label: 'Category' },
        { value: 'Author', label: 'Author' },
      ],
    },
    { '4': null },
    {
      '5': [
        { value: '0', label: 'Completion' },
        { value: '1', label: 'Leaderboard' },
        { value: '2', label: 'Reflection' },
        { value: '3', label: 'Takeaway' },
        { value: '4', label: 'Welcome' },
        { value: '5', label: 'Thanks' },
      ],
    },
  ];
  const tabIdMapping: { [key: string]: string } = {
    1: '5',
    2: '4',
    3: '5',
    4: '5',
    5: '5',
    6: '5',
    7: '5',
    9: '4',
    14: '4',
  };

  const getDefaultTabId = (screenId: number) => {
    return tabIdMapping[screenId.toString()] || '';
  };
  useEffect(() => {
    if (audioRef.current) {
      if (currentScreenId === 2) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
    const defaultTabId = getDefaultTabId(currentScreenId);
    setReviewInput((prev: any) => ({
      ...prev,
      review: '',
      tabId: defaultTabId ? defaultTabId : null,
      tabAttribute: '',
      tabAttributeValue: '',
    }));
    isMenuOpen && setIsMenuOpen(false);
  }, [currentScreenId, setReviewInput]);
  const handleSubmitReview = async (inputdata: any) => {
    if (!inputdata.reviewerId || !inputdata.reviewGameId) {
      toast({
        title: 'You are Unauthorized..!',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return false;
    } else if (!inputdata.tabId) {
      toast({
        title: 'Select Feedback Options',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return false;
    } else if (!inputdata.review) {
      toast({
        title: 'Review Field is Empty',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return false;
    }
    let reviewInputDatas: any = {};
    if (!inputdata.tabAttributeValue || !inputdata.tabAttribute) {
      if (inputdata?.tabId && inputdata?.reviewerId) {
        if (inputdata?.tabId == 5) {
          if (currentScreenId === 6) {
            reviewInputDatas = {
              ...reviewInput,
              tabAttribute: 'screenId',
              tabAttributeValue:
                Tab5attribute.indexOf(Number(currentScreenId)).toString() +
                '@' +
                profile?.currentQuest,
            };
          } else {
            reviewInputDatas = {
              ...reviewInput,
              tabAttribute: 'screenId',
              tabAttributeValue: Tab5attribute.indexOf(
                Number(currentScreenId),
              ).toString(),
            };
          }

          setReviewSubTabOptions([]);
        } else if (inputdata?.tabId == 4) {
          //for Story Tab *******

          if (currentScreenId == 9 || currentScreenId == 14) {
            const blockSeqId =
              currentScreenId == 9
                ? data.blockId
                : FeedBackoptionData[0]?.blockId;

            reviewInputDatas = {
              ...reviewInput,
              tabAttribute: 'blockSeqId',
              tabAttributeValue: blockSeqId,
            };
          } else {
            const blockSeqId = data?.blockId;
            setReviewSubTabOptions([]);
            reviewInputDatas = {
              ...reviewInput,
              tabAttribute: 'blockSeqId',
              tabAttributeValue: blockSeqId,
            };
          }
        } else if (inputdata?.tabId == 1) {
          reviewInputDatas = {
            ...reviewInput,
            tabAttribute: 'background',
            tabAttributeValue: 1,
          };
        } else if (inputdata?.tabId == 2) {
          reviewInputDatas = {
            ...reviewInput,
            tabAttribute: 'character',
            tabAttributeValue: 2,
          };
        } else {
          const subOptions = subTabOptionsForTabIds.find(
            (item: any) => Object.keys(item)[0] === inputdata?.tabId.toString(),
          );
          setReviewSubTabOptions(subOptions[inputdata?.tabId.toString()]);

          reviewInputDatas = { ...reviewInput };
        }
        /** To hide the sub tab options and set the subtab selection based on the current screen it here */
      }
    } else {
      if (currentScreenId == 9 || currentScreenId == 14) {
        const blockSeqId =
          currentScreenId == 9 ? data.blockId : FeedBackoptionData[0]?.blockId;

        reviewInputDatas = {
          ...reviewInput,
          tabAttribute: 'blockSeqId',
          tabAttributeValue: blockSeqId,
        };
      } else if (currentScreenId == 2) {
        const blockSeqId = data?.blockId;
        setReviewSubTabOptions([]);
        reviewInputDatas = {
          ...reviewInput,
          tabAttribute: 'blockSeqId',
          tabAttributeValue: blockSeqId,
        };
      } else {
        reviewInputDatas = { ...reviewInput };
      }
    }

    const addReviewResponse = await SubmitReview(
      JSON.stringify({ data: reviewInputDatas, id: reviewid }),
    );
    if (addReviewResponse?.status === 'Failure') {
      toast({
        title: 'Failed to Add Review',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      return false;
    }
    if (addReviewResponse?.status === 'Success') {
      toast({
        title: 'Review added Successfully..!',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
        containerStyle: {
          zIndex: replayState === 'replayPointPrompt' ? 999999 : 99999,
          marginTop: '150px',
        },
      });

      const defaultTabId = getDefaultTabId(currentScreenId);
      setReviewInput((prev: any) => ({
        ...prev,
        review: '',
        tabId: defaultTabId ? defaultTabId : null,
        tabAttribute: '',
        tabAttributeValue: '',
      }));
      if (addReviewResponse?.result) {
        if (addReviewResponse?.result === 1) {
          setIsAuthFailed({
            status: true,
            authMsg: 'You have already completed  the review for this game..!',
            reviewStatus: true,
          });
        }
      }

      // fetchGameData();
      return true;
    }
  };
  useEffect(() => {
    if (reviewInput?.tabId && reviewInput?.reviewerId) {
      if (reviewInput?.tabId == 5) {
        if (currentScreenId === 6) {
          setReviewInput((prev: Review) => ({
            ...prev,
            tabAttribute: 'screenId',
            tabAttributeValue:
              Tab5attribute.indexOf(Number(currentScreenId)).toString() +
              '@' +
              profile?.currentQuest,
          }));
        } else {
          setReviewInput((prev: Review) => ({
            ...prev,
            tabAttribute: 'screenId',
            tabAttributeValue: Tab5attribute.indexOf(
              Number(currentScreenId),
            ).toString(),
          }));
        }

        setReviewSubTabOptions([]);
      } else if (reviewInput?.tabId == 4) {
        //for Story Tab *******
        if (currentScreenId == 9 || currentScreenId == 14) {
          const blockSeqId =
            currentScreenId == 9
              ? data.blockId
              : FeedBackoptionData[0]?.blockId;

          setReviewInput((prev: Review) => ({
            ...prev,
            tabAttribute: 'blockSeqId',
            tabAttributeValue: blockSeqId,
          }));
        } else {
          const blockSeqId = data?.blockId;
          setReviewSubTabOptions([]);
          setReviewInput((prev: Review) => ({
            ...prev,
            tabAttribute: 'blockSeqId',
            tabAttributeValue: blockSeqId,
          }));
        }
      } else {
        const subOptions = subTabOptionsForTabIds.find(
          (item: any) => Object.keys(item)[0] === reviewInput?.tabId.toString(),
        );
        setReviewSubTabOptions(subOptions[reviewInput?.tabId.toString()]);
      }
    }
  }, [reviewInput.tabId]);

  useEffect(() => {
    /**Validate form */
    if (
      reviewInput.reviewGameId &&
      reviewInput.reviewerId &&
      reviewInput.tabId &&
      reviewInput.review
    ) {
      if (reviewInput.tabId === 3 || reviewInput.tabId === 5) {
        if (reviewInput.tabAttribute && reviewInput.tabAttributeValue) {
          setIsFormValid(true);
        } else {
          setIsFormValid(false);
        }
      } else {
        setIsFormValid(true);
      }
    } else {
      setIsFormValid(false);
    }
  }, [reviewInput]);

  const handleClose = () => {
    const element = document.getElementById('container');
    if (element) {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          alert(`${err.message}`);
        });
      }
    }
  };

  //no need for story
  const handleTabSelection = (e: any) => {
    e.preventDefault();
    if (e.target.value) {
      setReviewInput((prev: Review) => ({
        ...prev,
        tabId: e.target.value ?? null,
        tabAttribute: '',
        tabAttributeValue: '',
      }));
      setIsMenuOpen(true);
    } else {
      setReviewInput((prev: Review) => ({
        ...prev,
        tabId: selectedOption?.value ? selectedOption?.value : null,
        tabAttribute: '',
        tabAttributeValue: '',
      }));
      setReviewSubTabOptions([]);
    }
  };

  const handleSubTabSelection = (e: any) => {
    const selectedTabFileds = tabAttributeSets.find(
      (item) => Object.keys(item)[0] === reviewInput?.tabId.toString(),
    );
    setReviewInput((prev: Review) => ({
      ...prev,
      tabAttribute: e.target.value
        ? selectedTabFileds[reviewInput?.tabId.toString()]?.tabAttribute
        : null,
      tabAttributeValue: e.target.value ?? null,
    }));
  };

  const handleMenubtn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsMenuOpen(true);
  };

  // const toast = useToast();
  const handleReview = (e: any) => {
    setReviewInput((prev: Review) => ({ ...prev, review: e.target.value }));
  };

  const resetInputFields = () => {
    setReviewInput((prev) => ({
      ...prev,
      review: '',
      tabAttribute: '',
      tabAttributeValue: '',
    }));
  };

  const hanldeSubmit = async (data: any) => {
    const response = handleSubmitReview(data); //returns true or false
    if (response) {
      setIsMenuOpen(false);
      resetInputFields();
    }
  };
  const hanldeClose = () => {
    setIsFormValid(false);
    resetInputFields();
    setIsMenuOpen(false);
  };
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const startDemo = () => {
    onClose1();
    setCurrentScreenId(10);
  };

  const replayGame = () => {
    setType(gameInfo?.blocks[profile?.currentQuest]['1']?.blockChoosen);
    setData(gameInfo?.blocks[profile?.currentQuest]['1']);
    setCurrentScreenId(2);
  };
  const replayNextHandler = () => {
    const currentQuest = data
      ? parseInt(data?.blockPrimarySequence.split('.')[0])
      : null;
    // const nextLevel = currentQuest != null ?  String(currentQuest + 1) : null;
    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    if (demoBlocks.hasOwnProperty(nextLevel)) {
      setProfile((prev: any) => {
        const data = { ...prev };

        if (!profile.completedLevels.includes(String(nextLevel))) {
          data.completedLevels = [...data.completedLevels, String(nextLevel)];
        }
        return data;
      });

      setType(demoBlocks[nextLevel]['1']?.blockChoosen);
      setData(demoBlocks[nextLevel]['1']);
      setMotionEffect(true);
      setCurrentScreenId(13);
      return false;
    } else {
      /** Add feedback is at the end, if after completion, then show feedback */

      if (
        gameInfo.gameData?.gameIsShowReflectionScreen !== 'false' &&
        gameInfo?.reflectionQuestions.length > 0
      ) {
        //setFeedbackList([]);
        setCurrentScreenId(3); //Navigate to Reflection screen
        return false;
      } else if (gameInfo.gameData?.gameIsShowTakeaway !== 'false') {
        //setFeedbackList([]);
        setCurrentScreenId(7); //Navigate to Takeaway screen
        return false;
      } else {
        setType(null);
        setData(null);

        setCurrentScreenId(5); //Navigate to Thank you screen
        return false;
      }
    }
  };

  const handleAudioError = () => {
    console.error(
      'Failed to load video because no supported source was found.',
    );
  };

  useEffect(() => {
    const fetchSupportedLanguages = async () => {
      if (gameInfo?.gameData?.gameId > 0) {
        const resLang = await getGameLanguages(gameInfo?.gameData?.gameId);
        if (resLang?.status === 'Success') {
          if (resLang?.data.length > 0) {
            const data = resLang?.data;
            const ifEnglishExist = data.filter((lang: any) => lang.value === 1);
            if (ifEnglishExist.length === 0) {
              data.unshift({ value: 1, label: 'English' });
            }
            setGameLanguages(data);
            setHasMulitLanguages(true);
          } else {
            setGameLanguages([{ value: 1, label: 'English' }]);
            setProfileData((prev: any) => ({
              ...prev,
              language: 1,
            }));
            if (Gameid) {
              setPreLogDatas((prev: any) => ({
                ...prev,
                previewProfile: {
                  ...prev.previewProfile,
                  language: 1,
                },
              }));
            }
            setHasMulitLanguages(true);
          }
        }
      }
    };
    fetchSupportedLanguages();
  }, []);

  const getCurrentResolution = () => {
    const body = document.getElementById('body');
    body.style.width = `${window.innerWidth}px`;
    body.style.height = `${window.innerHeight}px`;

    return body;
  };

  const dontShowTopMenu = ![3, 4, 5, 6, 7, 10].includes(currentScreenId);

  useEffect(() => {
    if (FeedbackNavigatenext === true) {
      setisScreenshot(false);
      getData(data);
    }
  }, [FeedbackNavigatenext]);

  const getFeedbackData = (data?: any) => {
    setisScreenshot(true);

    const groupedFeedback: { [key: string]: any[] } = {};

    feedbackList.forEach((feedback) => {
      if (!(feedback.Seq in groupedFeedback)) {
        groupedFeedback[feedback.Seq] = [];
      }
      // Add feedback only if it's not a duplicate based on options and type
      const existingFeedback = groupedFeedback[feedback.Seq].find(
        (f) =>
          f.Options.options === feedback.Options.options &&
          f.type === feedback.type,
      );
      if (!existingFeedback) {
        groupedFeedback[feedback.Seq].push(feedback);
      }
    });

    const firstPageFeedback: any[] = [];
    Object.keys(groupedFeedback).forEach((seq: any) => {
      groupedFeedback[seq].forEach((feedback) => {
        if (profile.currentQuest == feedback.quest) {
          firstPageFeedback.push(feedback);
        }
      });
    });

    let newRemainingSentences;
    let ScreenShotScore;
    if (
      firstPageFeedback.length !== 0 &&
      FeedbackcurrentPosition < firstPageFeedback.length
    ) {
      newRemainingSentences =
        firstPageFeedback[FeedbackcurrentPosition].feedbackcontent;
      ScreenShotScore = firstPageFeedback[FeedbackcurrentPosition].totalPoints;
      // getOption for FeedBack
      const getgameinfoblockchoosen = gameInfo?.blocks[profile?.currentQuest];
      const getArray = [];
      for (const key in getgameinfoblockchoosen) {
        if (getgameinfoblockchoosen[key].blockChoosen === 'Interaction') {
          getArray.push(getgameinfoblockchoosen[key]);
        }
      }
      setInterActionBlockArray(firstPageFeedback.length); //Prabakaran worked. Newly added

      const GetSeqData = getArray.filter((item: any) => {
        return (
          item?.blockPrimarySequence ===
          firstPageFeedback[FeedbackcurrentPosition].Seq
        );
      });
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (option?.qpSequence === GetSeqData[0]?.blockPrimarySequence) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (option?.qpSequence === GetSeqData[0]?.blockPrimarySequence) {
            optionsFiltered.push(option);
          }
        }
      }

      const SelectedoptionsFiltered = optionsFiltered.filter(
        (key: any) =>
          key?.qpOptions ==
          firstPageFeedback[FeedbackcurrentPosition].Options['options'],
      );
      const selectoptionfeed = SelectedoptionsFiltered[0].qpOptions
        ? SelectedoptionsFiltered[0].qpOptions
        : 'null';
      setOptions(optionsFiltered);
      setFeedBackSelectedoptionData(selectoptionfeed);
      setFeedBackoptionData(GetSeqData);
      setFeedbackCurrentPosition(FeedbackcurrentPosition + 1);
      setFeedbackRemainingSentences(newRemainingSentences);
      setInterActionScore(ScreenShotScore);
    } else {
      setInterActionBlockArray(0);
      setOptions(null);
      setFeedBackSelectedoptionData(null);
      setFeedBackoptionData(null);
      setFeedbackCurrentPosition(0);
      setFeedbackRemainingSentences(null);
      setFeedbackNavigateNext(true);
      setInterActionScore(null);
    }
  };

  useEffect(() => {
    const updatepreviousdatas = async () => {
      if (!previewid && !reviewid) {
        const data = {
          previewLogId: getPrevLogDatas.previewLogId,
          playerId: gameInfo?.reviewer?.ReviewerId ?? user?.data?.id,
          playerType: gameInfo?.reviewer?.ReviewerId
            ? 'reviewer'
            : user?.data?.id
            ? 'creator'
            : null,
          previewGameId: gameInfo?.gameId ?? null,
          nevigatedSeq: getPrevLogDatas.nevigatedSeq,
          screenIdSeq: getPrevLogDatas.screenIdSeq,
          lastActiveBlockSeq: getPrevLogDatas.lastActiveBlockSeq,
          selectedOptions: getPrevLogDatas.selectedOptions,
          previewProfile: getPrevLogDatas.previewProfile,
          lastBlockModifiedDate: getPrevLogDatas.lastBlockModifiedDate,
          lastModifiedBlockSeq: getPrevLogDatas.lastModifiedBlockSeq,
          playerInputs: getPrevLogDatas.playerInputs,
          previewScore: getPrevLogDatas.previewScore,
          questState: getPrevLogDatas.questState,
          audioVolumeValue: getPrevLogDatas.audioVolumeValue,
        };
        if (data.playerId && data.playerType) {
          const previousDataString = JSON.stringify(data);
          const updatePreviewLogsResponse = await updatePreviewlogs(
            previousDataString,
          );
        } else {
          setIsAuthFailed({
            status: true,
            authMsg: 'Your session has timed out. Please login then try again',
            reviewStatus: false,
          });
          return;
        }
      }
    };
    updatepreviousdatas();
  }, [getPrevLogDatas]);

  //  Newly Added  for prviouse stored
  const SetPreviouseStored = (currentdata: any) => {
    if (currentdata !== null) {
      const currentQuest = currentdata
        ? parseInt(currentdata?.blockPrimarySequence.split('.')[0])
        : null;
      if (currentdata?.blockChoosen === 'Interaction') {
        if (currentQuest === parseInt(profile.currentQuest)) {
          if (getPrevLogDatas.selectedOptions[profile?.currentQuest]) {
            const existingIndex = getPrevLogDatas.selectedOptions[
              profile?.currentQuest
            ]?.findIndex((item: any) => item.blockId === currentdata.blockId);

            if (existingIndex !== -1) {
              const updatedOptions = [
                ...getPrevLogDatas.selectedOptions[profile?.currentQuest],
              ];
              updatedOptions[existingIndex] = {
                blockId: currentdata.blockId,
                optionId: OptionSelectId,
              };
              setPreLogDatas((prev: any) => ({
                ...prev,
                selectedOptions: {
                  ...prev.selectedOptions,
                  [profile?.currentQuest]: updatedOptions,
                },
              }));
            } else {
              setPreLogDatas((prev: any) => ({
                ...prev,
                selectedOptions: {
                  ...prev.selectedOptions,
                  [profile?.currentQuest]: [
                    ...prev.selectedOptions[profile?.currentQuest],
                    { blockId: currentdata.blockId, optionId: OptionSelectId },
                  ],
                },
              }));
            }
          } else {
            setPreLogDatas((prev: any) => ({
              ...prev,
              selectedOptions: {
                ...prev.selectedOptions,
                [profile?.currentQuest]: [
                  { blockId: currentdata.blockId, optionId: OptionSelectId },
                ],
              },
            }));
          }
        } else {
          setPreLogDatas((prev: any) => ({
            ...prev,
            selectedOptions: {
              [profile?.currentQuest]: [
                { blockId: currentdata.blockId, optionId: OptionSelectId },
              ],
            },
          }));
        }
      }
    }
  };
  const removeCurrentQuest = (selectedOptions: any, currentquest: number) => {
    delete selectedOptions[currentquest];
    return selectedOptions;
  };
  /** replay prompt functions for replay point & previous navigation to chapter selection screen*/
  const handleReplayButtonClick = (replayType: string) => {
    const updatedFeedbackList = feedbackList.filter(
      (feedback) => feedback.quest != profile.currentQuest,
    );
    setFeedbackList(updatedFeedbackList);
    if (replayState === 'replayPointprompt') {
      setFeed('');
      setOptions(null);
      setFeedBackSelectedoptionData(null);
      setFeedBackoptionData(null);
      setSelectedOption(null);
    }
    /**replayType become ['mandatoryReplay', 'optionalReplay','replayPointPrompt'] **/
    if (replayType === 'mandatoryReplay') {
      //s***************
      if (Object.keys(questState).length > 0) {
        if (questState[parseInt(profile?.currentQuest)] === 'Started') {
          // Remove matching object from profile?.score
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        } else if (
          questState[parseInt(profile?.currentQuest)] === 'replayallowed'
        ) {
          // Remove matching object from profile?.replayScore
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        } else {
          if (profile?.replayScore.length > 0) {
            profile.replayScore = profile?.replayScore.filter(
              (item: any) => item.quest !== parseInt(profile?.currentQuest),
            );
          }
          if (profile?.score.length > 0) {
            profile.score = profile?.score.filter(
              (item: any) => item.quest !== parseInt(profile?.currentQuest),
            );
          }
        }
      } else {
        if (profile?.replayScore.length > 0) {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
        if (profile?.score.length > 0) {
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
      }
      if (Gameid) {
        setPreLogDatas((prev: any) => ({
          ...prev,
          selectedOptions: removeCurrentQuest(
            getPrevLogDatas?.selectedOptions,
            parseInt(profile?.currentQuest),
          ),
          nevigatedSeq: removeCurrentQuest(
            getPrevLogDatas?.nevigatedSeq,
            parseInt(profile?.currentQuest),
          ),
          previewScore: profile,
        }));
      }
    }
    if (replayType === 'replayPointPrompt') {
      setFeed('');
      if (Object.keys(questState).length) {
        if (questState[parseInt(profile?.currentQuest)] === 'Started') {
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
          /***Update quest state when replay from started*/
          if (Gameid) {
            setPreLogDatas((prev: any) => ({
              ...prev,
              questState: {
                ...questState,
                [parseInt(profile?.currentQuest)]: 'replayallowed',
              },
            }));
          }
        } else if (
          questState[parseInt(profile?.currentQuest)] === 'replayallowed'
        ) {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
      } else {
        if (profile?.replayScore.length > 0) {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
        if (profile?.score.length > 0) {
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
          if (Gameid) {
            setPreLogDatas((prev: any) => ({
              ...prev,
              questState: {
                ...questState,
                [parseInt(profile?.currentQuest)]: 'replayallowed',
              },
            }));
          }
        }
      }
      if (Gameid) {
        setPreLogDatas((prev: any) => ({
          ...prev,
          selectedOptions: removeCurrentQuest(
            getPrevLogDatas?.selectedOptions,
            parseInt(profile?.currentQuest),
          ),
          nevigatedSeq: removeCurrentQuest(
            getPrevLogDatas?.nevigatedSeq,
            parseInt(profile?.currentQuest),
          ),
          previewScore: profile,
        }));
      }
    }
    if (replayType === 'optionalReplay') {
      setFeed('');
      if (Object.keys(questState).length) {
        if (questState[parseInt(profile?.currentQuest)] === 'Started') {
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
          /***Update quest state when replay from started*/
          if (Gameid) {
            setPreLogDatas((prev: any) => ({
              ...prev,
              questState: {
                ...questState,
                [parseInt(profile?.currentQuest)]: 'replayallowed',
              },
            }));
          }
        } else if (
          questState[parseInt(profile?.currentQuest)] === 'replayallowed'
        ) {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
      } else {
        if (profile?.replayScore.length > 0) {
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
        }
        if (profile?.score.length > 0) {
          profile.score = profile?.score.filter(
            (item: any) => item.quest !== parseInt(profile?.currentQuest),
          );
          if (Gameid) {
            setPreLogDatas((prev: any) => ({
              ...prev,
              questState: {
                ...questState,
                [parseInt(profile?.currentQuest)]: 'replayallowed',
              },
            }));
          }
        }
      }

      if (Gameid) {
        setPreLogDatas((prev: any) => ({
          ...prev,
          selectedOptions: removeCurrentQuest(
            getPrevLogDatas?.selectedOptions,
            parseInt(profile?.currentQuest),
          ),
          nevigatedSeq: removeCurrentQuest(
            getPrevLogDatas?.nevigatedSeq,
            parseInt(profile?.currentQuest),
          ),
          previewScore: profile,
        }));
      }
    }
    setType(demoBlocks[profile?.currentQuest]['1']?.blockChoosen);
    setData(demoBlocks[profile?.currentQuest]['1']);
    if (
      demoBlocks[profile?.currentQuest]['1']?.blockChoosen === 'Interaction'
    ) {
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (
            option?.qpSequence ===
            demoBlocks[profile?.currentQuest]['1']?.blockPrimarySequence
          ) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (
            option?.qpSequence ===
            demoBlocks[profile?.currentQuest]['1']?.blockPrimarySequence
          ) {
            optionsFiltered.push(option);
          }
        }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }
      setOptions(optionsFiltered);
    }
    setCurrentScreenId(2);
  };

  const QuestBlocklastpaused = async (type: string = null) => {
    const setBlockData = async (
      lastActivityquest: any,
      findActiveBlockId: any,
      SetLastSeqData: any,
    ) => {
      if (SetLastSeqData !== undefined) {
        profile.score = profile?.score.filter(
          (item: any) => item.seqId !== SetLastSeqData.blockPrimarySequence,
        );
        profile.replayScore = profile?.replayScore.filter(
          (item: any) => item.seqId !== SetLastSeqData.blockPrimarySequence,
        );
        const updatedFeedbackList = feedbackList?.filter(
          (item) => item.Seq !== SetLastSeqData.blockPrimarySequence,
        );
        setFeedbackList(updatedFeedbackList);
        setProfile((prev: any) => ({
          ...prev,
          currentQuest: lastActivityquest,
        }));
        setData(SetLastSeqData);
        setType(SetLastSeqData?.blockChoosen);
        if (SetLastSeqData?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          const primarySequence = findActiveBlockId[0];
          const gameInfoquest = gameInfo.questOptions;
          for (const option of gameInfoquest) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpQuestionId === primarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpQuestionId === primarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          const gameinfodata = gameInfo?.gameData?.gameShuffle;
          if (gameinfodata === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ]; // Swap elements at indices i and j
            }
          }
          setOptions(optionsFiltered);
        }
        setReplayIsOpen(false);
        setCurrentScreenId(2);
        return false;
      } else {
        return;
      }
    };
    if (getPrevLogDatas.nevigatedSeq && type !== 'owner') {
      const LastPreviousActiveBlock = getPrevLogDatas.lastActiveBlockSeq;
      const lastActiveBlock = Object.keys(getPrevLogDatas.lastActiveBlockSeq);
      const lastActivityquest: number = parseInt(lastActiveBlock[0]);
      const findActiveBlockId = LastPreviousActiveBlock[lastActivityquest];
      let SetLastSeqData: any;
      for (const key in gameInfo.blocks[lastActivityquest]) {
        const data = gameInfo.blocks[lastActivityquest][key];
        if (data.blockId === findActiveBlockId[0]) {
          SetLastSeqData = data;
          break;
        }
      }
      const result = await setBlockData(
        lastActivityquest,
        findActiveBlockId,
        SetLastSeqData,
      );
    } else if (type === 'owner' && creatorDataSlice?.screenId === 2) {
      const lastActivityquest: number = parseInt(
        creatorDataSlice?.currentQuest,
      );
      const pSeq = `${lastActivityquest}.${creatorDataSlice?.activeBlockSeq}`;
      let SetLastSeqData = {};
      let activeBlock: number[] = [];

      SetLastSeqData =
        gameInfo?.blocks && gameInfo.blocks[lastActivityquest]
          ? Object.values(gameInfo.blocks[lastActivityquest]).find(
              (item: any) => {
                if (
                  item.blockPrimarySequence === pSeq &&
                  item.blockQuestNo === lastActivityquest
                ) {
                  activeBlock.push(item?.blockId);
                  return true;
                }
                return false;
              },
            )
          : {};
      if (activeBlock && lastActivityquest && SetLastSeqData) {
        const result = await setBlockData(
          lastActivityquest,
          activeBlock,
          SetLastSeqData,
        );
        dispatch(
          updatePreviewData({
            gameId: gameInfo.gameId,
            action: null,
            isModified: false,
          }),
        );
      } else {
        dispatch(
          updatePreviewData({
            gameId: gameInfo.gameId,
            action: null,
            isModified: false,
          }),
        );
        if (activeBlock.length <= 0) {
          if (
            getPrevLogDatas?.nevigatedSeq &&
            getPrevLogDatas.nevigatedSeq.hasOwnProperty(
              creatorDataSlice.currentQuest,
            )
          ) {
            const navSeqArray = [
              ...getPrevLogDatas.nevigatedSeq[creatorDataSlice.currentQuest],
            ];
            navSeqArray.length === 0
              ? setCurrentScreenId(13)
              : navSeqArray.pop();
            if (navSeqArray.length === 0) {
              setReplayState('noNavigation');
              setReplayIsOpen(true);
            } else {
              // Find the index of the element '10'
              const currentSeq =
                creatorDataSlice?.currentQuest +
                '.' +
                creatorDataSlice?.activeBlockSeq;
              let index = navSeqArray?.indexOf(currentSeq);
              if (index !== -1) {
                // Remove elements starting from the index of '10'
                navSeqArray.splice(index);
              }
              const NewNavigationSeq = {
                ...getPrevLogDatas.nevigatedSeq,
                [creatorDataSlice.currentQuest]: navSeqArray,
              };
              setPreLogDatas((prev: any) => ({
                ...prev,
                nevigatedSeq: {
                  [creatorDataSlice.currentQuest]: navSeqArray,
                  ...prev.nevigatedSeq,
                },
              }));
              const prevCreatorDataSlice = {
                ...creatorDataSlice,
                activeBlockSeq: navSeqArray.pop(),
              };
              creatorDataSlice = { ...prevCreatorDataSlice };

              let SetLastSeqData = {};
              let activeBlock: number[] = [];
              SetLastSeqData =
                gameInfo?.blocks &&
                gameInfo.blocks[creatorDataSlice.currentQuest]
                  ? Object.values(
                      gameInfo.blocks[creatorDataSlice.currentQuest],
                    ).find((item: any) => {
                      if (
                        item.blockPrimarySequence ==
                          creatorDataSlice.activeBlockSeq &&
                        item.blockQuestNo == creatorDataSlice.currentQuest
                      ) {
                        activeBlock.push(item?.blockId);
                        return true;
                      }
                      return false;
                    })
                  : {};

              //to get the previous seq
              const result = await setBlockData(
                creatorDataSlice.currentQuest,
                activeBlock,
                SetLastSeqData,
              );
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    if (creatorDataSlice?.screenId) {
      if (creatorDataSlice?.screenId === 2) {
        //Story
        if (!promptType) {
          QuestBlocklastpaused('owner');
        }
      } else if (creatorDataSlice?.screenId === 6) {
        //Completion Screen
        const currentQuest = creatorDataSlice?.CompKeyCount
          ? creatorDataSlice?.CompKeyCount + 1
          : 1;
        setProfile((prev: any) => ({
          ...prev,
          currentQuest: currentQuest,
        }));
        setCurrentQuestNo(currentQuest);
        setCurrentScreenId(creatorDataSlice?.screenId);
      } else {
        setCurrentScreenId(creatorDataSlice?.screenId);
      }
      /***to reset landing screen after set the screen */
      if (previewid) {
        dispatch(resetGameModifiedState(previewid));
      }
      /***to reset landing screen after set the screen */
    }
  }, [creatorDataSlice, gameInfo]);

  useEffect(() => {
    setTimeout(() => {
      setMotionEffect(false);
    }, 100);
  }, [currentScreenId, ModelControl, replayIsOpen]);
  const parseSequence = (seq: any) => {
    return seq.split('.').map(Number);
  };
  const findPreviousSequence = (array: any, currentSeq: any) => {
    const parsedCurrentSeq = parseSequence(currentSeq);
    let previousSeq = null;

    for (let obj of array) {
      const parsedSeq = parseSequence(obj.blockPrimarySequence);

      if (
        parsedSeq[0] === parsedCurrentSeq[0] &&
        parsedSeq[1] < parsedCurrentSeq[1]
      ) {
        if (
          !previousSeq ||
          parsedSeq[1] > parseSequence(previousSeq.blockPrimarySequence)[1]
        ) {
          previousSeq = obj;
        }
      }
    }

    return previousSeq;
  };
  const questDeleteNavigation = () => {
    if (creatorDataSlice?.currentQuest) {
      const currentQuest = creatorDataSlice.currentQuest;
      const current = gameInfo.blocks[currentQuest][1];
      const { value, DelseQ, quest } = promptType;
      dispatch(resetGameModifiedState(getPrevLogDatas.previewGameId));
      if (value === '1.1') {
        setReplayState('noBlock');
        setReplayIsOpen(true);
      } else {
        const valuesArray =
          demoBlocks && demoBlocks[profile.currentQuest]
            ? Object.values(demoBlocks[profile.currentQuest])
            : null;
        const previousSeqObj = findPreviousSequence(valuesArray, value);
        if (previousSeqObj) {
          setData(previousSeqObj);
          setType(previousSeqObj?.blockChoosen);
          if (previousSeqObj?.blockChoosen === 'Interaction') {
            const optionsFiltered = [];
            const primarySequence = previousSeqObj?.blockPrimarySequence;
            const gameInfoquest = gameInfo.questOptions;
            for (const option of gameInfoquest) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (option?.qpSequence === primarySequence) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );

                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (option?.qpSequence === primarySequence) {
                  optionsFiltered.push(option);
                }
              }
            }
            const gameinfodata = gameInfo?.gameData?.gameShuffle;
            if (gameinfodata === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ]; // Swap elements at indices i and j
              }
            }
            setOptions(optionsFiltered);
          }
          if (currentScreenId !== 2) {
            setCurrentScreenId(2);
          }
          return;
        } else {
          setReplayState('noBlock');
          setReplayIsOpen(true);
        }
      }
    }
  };
  const handleClick = async () => {
    if (replayState === 'questDelete') {
      await fetchCreatorDemoData();

      setReplayIsOpen(false);
      setCurrentScreenId(13);
      setNavTrack([]);
    } else if (replayState === 'blockDelete') {
      if (gameInfo?.blocks) {
        setDemoBlocks(gameInfo.blocks);
      }
      setReplayIsOpen(false);
      questDeleteNavigation();
    } else if (replayState === 'noNavigation') {
      if (data && type) {
        setData(data);
        setType(type);
        if (data?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === data?.blockPrimarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === data?.blockPrimarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }

          setOptions(optionsFiltered);
        }
        setCurrentScreenId(2);
      }
      setReplayIsOpen(false);
    } else if (replayState === 'noBlock') {
      setReplayIsOpen(false);
      setCurrentScreenId(13);
    } else if (replayState === 'Nocompletion') {
      setReplayIsOpen(false);
      setCurrentScreenId(13);
    }
    dispatch(
      updatePreviewData({
        gameId: gameInfo.gameId,
        action: null,
        isModified: false,
      }),
    );
  };

  useEffect(() => {
    if (!(gameInfo?.reviewer?.ReviewerId || user?.data?.id)) {
      setIsAuthFailed({
        status: true,
        authMsg: 'Your session has timed out. Please login then try again',
        reviewStatus: false,
      });
    }
  }, [gameInfo?.reviewer?.ReviewerId, user?.data?.id]);

  const tryForFeedbackAllTogether = async () => {
    if (
      feedbackList.length !== 0 &&
      gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
    ) {
      const Completionpage = Object.entries(questState).map(
        ([questId, status]) => ({ questId, status }),
      );
      const OpenStraigntCompletionPage = Completionpage.find(
        (row: any) =>
          row.questId === profile.currentQuest && row.status === 'completed',
      );

      if (
        feedbackList.length !== 0 &&
        feedbackList?.find((item: any) => item.quest == profile.currentQuest)
      ) {
        getFeedbackData();
        setFeedbackNavigateNext(false);
        setFirstLoading(true);
        setCurrentScreenId(14); //Navigate to together all feedback
        return false;
      }
    }
  };
  useEffect(() => {
    sessionStorage.setItem('lastGameScreen', currentScreenId.toString());
  }, [currentScreenId]);

  // Restore when the game loads
  useEffect(() => {
    const savedScreen = sessionStorage.getItem('lastGameScreen');
    if (savedScreen) {
      setCurrentScreenId(parseInt(savedScreen, 10));
    }
  }, []);

  return (
    <ProfileContext.Provider value={{ profileData, setMotionEffect }}>
      {isAuthFailed.status === false ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: motionEffect ? 0 : 1 }}
        >
          <TopMenuBar
            isLeaderboardEnabled={isLeaderboardEnabled}
            setIsLeaderboardEnabled={setIsLeaderboardEnabled}
            dontShowTopMenu={dontShowTopMenu}
            preloadedAssets={preloadedAssets}
            currentScreenId={currentScreenId}
            setCurrentScreenId={setCurrentScreenId}
            isSettingOpen={isSettingOpen}
            setIsSettingOpen={setIsSettingOpen}
            setHomeLeaderBoard={setHomeLeaderBoard}
            profileData={profileData}
            gameInfo={gameInfo}
            demoBlocks={demoBlocks}
            data={data}
            setAudioObj={setAudioObj}
            audioObj={audioObj}
            questState={questState}
            setIsOpenCustomModal={setIsOpenCustomModal}
            EnumType={EnumType}
            getPrevLogDatas={getPrevLogDatas}
            setPreLogDatas={setPreLogDatas}
            imageSrc={preloadedAssets.backgroundImage}
            homeLeaderBoard={homeLeaderBoard}
            formData={gameInfo?.gameData}
            getData={getData}
            setPlayerTodayScore={setPlayerTodayScore}
            playerTodayScore={playerTodayScore}
            setCurrentQuestNo={setCurrentQuestNo}
            setFirstLoading={setFirstLoading}
            handleMusicVolume={handleMusicVolume}
          />
          <Flex
            height="100vh"
            className={
              currentScreenId === 2 || currentScreenId === 15
                ? ''
                : 'EntirePreview'
            }
          >
            {ModelControl === true ||
            NavigateBlockEmpty === true ||
            (replayIsOpen && replayState === 'Prompt') ? (
              <>
                <ModelPopup
                  ModelControl={ModelControl}
                  setModelControl={setModelControl}
                  backGroundImg={preloadedAssets.backgroundImage}
                  preloadedAssets={preloadedAssets}
                  getPrevLogDatas={getPrevLogDatas}
                  setCurrentScreenId={setCurrentScreenId}
                  setData={setData}
                  setType={setType}
                  gameInfo={gameInfo.blocks}
                  setOptions={setOptions}
                  gameInfoquest={gameInfo.questOptions}
                  gameinfodata={gameInfo.gameData.gameShuffle}
                  isSetStoryScreen={isSetStoryScreen}
                  isStoryScreen={isStoryScreen}
                  setPreLogDatas={setPreLogDatas}
                  NavigateBlockEmpty={NavigateBlockEmpty}
                  setNavigateBlockEmpty={setNavigateBlockEmpty}
                  profileData={profileData}
                  setQuestState={setQuestState}
                  setReplayState={setReplayState}
                  setReplayIsOpen={setReplayIsOpen}
                  replayState={replayState}
                  QuestBlocklastpaused={QuestBlocklastpaused}
                />
              </>
            ) : (
              ''
            )}
            {replayState !== 'Prompt' && replayIsOpen && (
              <ReplayScore
                preloadedAssets={preloadedAssets}
                setReplayIsOpen={setReplayIsOpen}
                handleReplayButtonClick={handleReplayButtonClick}
                replayState={replayState}
                setCurrentScreenId={setCurrentScreenId}
                gameInfo={gameInfo}
                profilescore={profilescore}
                getPrevLogDatas={getPrevLogDatas}
                setData={setData}
                setType={setType}
                gameInfoquest={gameInfo.questOptions}
                gameinfodata={gameInfo.gameData.gameShuffle}
                profileData={profileData}
                setQuestState={setQuestState}
                setOptions={setOptions}
                setPreLogDatas={setPreLogDatas}
                replayNextHandler={replayNextHandler}
                data={data}
                handleClick={handleClick}
                feed={feed}
                setSelectedOption={setSelectedOption}
                selectedOption={selectedOption}
                setAudioObj={setAudioObj}
                isScreenshot={isScreenshot}
                options={options}
              />
            )}
            {isCompleteReview === true && (
              <CompletionReview
                preloadedAssets={preloadedAssets}
                setIsCompleteReview={setIsCompleteReview}
                reviewInput={reviewInput}
                setReviewInput={setReviewInput}
                setCompleteTrue={setCompleteTrue}
              />
            )}

            <>
              {(currentScreenId === 2 ||
                currentScreenId === 9 ||
                currentScreenId === 14) && (
                <>
                  {gameInfo?.assets?.gasAssetName === 'Medieval office' && (
                    <BackgroundGLB
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}
                  {gameInfo?.assets?.gasAssetName === 'Medieval emporium' && (
                    <Emporium
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}
                  {gameInfo?.assets?.gasAssetName === 'Futuristic office' && (
                    <FuturisticOffice
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Futuristic City' && (
                    <FurturisticCity
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Futuristic Lab' && (
                    <FuturistiLab
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Medieval castle' && (
                    <Castle
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Magical office' && (
                    <Office
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Magical underground' && (
                    <Underground
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Magical garden' && (
                    <MagicalGarden
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Realistic workplace' && (
                    <RealWorkplace
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Realistic Factory' && (
                    <RealFactory
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                  {gameInfo?.assets?.gasAssetName === 'Realistic office' && (
                    <RealisticOffice
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}

                   {gameInfo?.assets?.gasAssetName === 'Future Theme Lab' && (
                    <FutureThemeLab
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                   {gameInfo?.assets?.gasAssetName === 'Future Theme Workshop' && (
                    <FutureThemeWorkshop
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                   {gameInfo?.assets?.gasAssetName === 'Future Theme Lab 1' && (
                    <FutureThemeLab1
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}
                   {gameInfo?.assets?.gasAssetName === 'Future Theme Workshop 1' && (
                    <FutureThemeWorkShop1
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                    />
                  )}{' '}

                </>
              )}
            </>
            {(() => {
              switch (currentScreenId) {
                case 0:
                  return (
                    <>
                      {
                        <PlayInfo
                          onOpen={onOpen1}
                          onClose={onClose1}
                          isOpen={true}
                          startDemo={startDemo}
                          setIsGetsPlayAudioConfirmation={
                            setIsGetsPlayAudioConfirmation
                          }
                        />
                      }
                    </>
                  );
                case 1:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          backgroundImage={preloadedAssets?.introBgImage}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                          backgroundColor={'#0d161e'}
                        >
                          <Box className="Images" h={'100vh !important'}>
                            <Welcome
                              intro={audio}
                              currentScreenId={currentScreenId}
                              setCurrentScreenId={setCurrentScreenId}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.backgroundImage}
                              screen={preloadedAssets.Screen5}
                              preview={true}
                              preloadedAssets={preloadedAssets}
                              setPreLogDatas={setPreLogDatas}
                              getPrevLogDatas={getPrevLogDatas}
                              profileData={profileData}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 2:
                  return (
                    <>
                      {data && type && (
                        <>
                          <Story
                            isScreenshot={isScreenshot}
                            setModalLoaded={setModalLoaded}
                            modalLoaded={modalLoaded}
                            selectedNpc={gameInfo?.gameNonPlayerUrl}
                            selectedPlayer={selectedPlayer}
                            formData={gameInfo?.gameData}
                            // backGroundImg={preloadedAssets.backgroundImage}
                            data={data}
                            type={type}
                            handleValidate={handleValidate}
                            resMsg={resMsg}
                            feed={feed}
                            getData={getData}
                            options={options}
                            option={selectedOption}
                            profileData={profileData}
                            voiceIds={voiceIds}
                            setAudioObj={setAudioObj}
                            setIsGetsPlayAudioConfirmation={
                              setIsGetsPlayAudioConfirmation
                            }
                            setIsPrevNavigation={setIsPrevNavigation}
                            setNavTrack={setNavTrack}
                            navTrack={navTrack}
                            gameInfo={gameInfo}
                            preloadedAssets={preloadedAssets}
                            replayGame={replayGame}
                            replayNextHandler={replayNextHandler}
                            setType={setType}
                            setData={setData}
                            isOptionalReplay={isOptionalReplay}
                            setisOptionalReplay={setisOptionalReplay}
                            setisReplay={setisReplay}
                            profilescore={profilescore}
                            isReplay={isReplay}
                            imageSrc={preloadedAssets.Replay}
                            questState={questState}
                            LastModiPrevData={LastModiPrevData}
                            setPreLogDatas={setPreLogDatas}
                            getPrevLogDatas={getPrevLogDatas}
                            RepeatSelectOption={RepeatSelectOption}
                            RepeatPrevOption={RepeatPrevOption}
                            Player={Player}
                            ModelPlayer={ModelPlayer}
                            /**Model Components */
                            setScore={setScore}
                            SetAudioOptions={SetAudioOptions}
                            score={score}
                            AudioOptions={AudioOptions}
                            upComingBlockChoosen={upComingBlockChoosen}
                            feedbackList={feedbackList}
                            setFeedbackList={setFeedbackList}
                            currentScreenId={currentScreenId}
                            SetGlbPlayingDetails={SetGlbPlayingDetails}
                            setIsZoomComplete={setIsZoomComplete}
                            isZoomComplete={isZoomComplete}
                            setNonPlayerNameLanguage={setNonPlayerNameLanguage}
                            NonPlayerNameLanguage={NonPlayerNameLanguage}
                          />
                        </>
                      )}
                    </>
                  );
                case 3:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box className="Game-Screen">
                          <Box className="Images">
                            <Reflection
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.RefBg}
                              reflectionQuestions={
                                gameInfo?.reflectionQuestions
                              }
                              gameInfo={gameInfo}
                              setCurrentScreenId={setCurrentScreenId}
                              preloadedAssets={preloadedAssets}
                              setPreLogDatas={setPreLogDatas}
                              getPrevLogDatas={getPrevLogDatas}
                              FeedbackcurrentPosition={FeedbackcurrentPosition}
                              setFeedbackCurrentPosition={
                                setFeedbackCurrentPosition
                              }
                              interactionBlockArray={interactionBlockArray}
                              profileData={profileData}
                              getFeedbackData={getFeedbackData}
                              feedbackList={feedbackList}
                              setInterActionBlockArray={
                                setInterActionBlockArray
                              }
                              setFeedbackNavigateNext={setFeedbackNavigateNext}
                              setCurrentQuestNo={setCurrentQuestNo}
                              setFirstLoading={setFirstLoading}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 4:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          // backgroundImage={preloadedAssets.StarsBg}
                          backgroundImage={preloadedAssets?.introBgImage}
                          backgroundColor={'#0d161e'}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images" zIndex={99}>
                            <LeaderBoard
                              homeLeaderBoard={homeLeaderBoard}
                              setHomeLeaderBoard={setHomeLeaderBoard}
                              setCurrentScreenId={setCurrentScreenId}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.Lead}
                              getData={getData}
                              data={data}
                              gameInfo={gameInfo}
                              preloadedAssets={preloadedAssets}
                              setPlayerTodayScore={setPlayerTodayScore}
                              playerTodayScore={playerTodayScore}
                              setCurrentQuestNo={setCurrentQuestNo}
                              setFirstLoading={setFirstLoading}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 5:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          // backgroundImage={preloadedAssets.StarsBg}
                          backgroundImage={preloadedAssets?.introBgImage}
                          backgroundColor={'#0d161e'}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images">
                            <ThankYou
                              setCurrentScreenId={setCurrentScreenId}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.ThankYou}
                              preloadedAssets={preloadedAssets}
                              getPrevLogDatas={getPrevLogDatas}
                              setPreLogDatas={setPreLogDatas}
                              gameInfo={gameInfo}
                              FeedbackcurrentPosition={FeedbackcurrentPosition}
                              setFeedbackCurrentPosition={
                                setFeedbackCurrentPosition
                              }
                              interactionBlockArray={interactionBlockArray}
                              profileData={profileData}
                              getFeedbackData={getFeedbackData}
                              feedbackList={feedbackList}
                              setInterActionBlockArray={
                                setInterActionBlockArray
                              }
                              setFeedbackNavigateNext={setFeedbackNavigateNext}
                              setCurrentQuestNo={setCurrentQuestNo}
                              setFirstLoading={setFirstLoading}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 6:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          // backgroundImage={preloadedAssets.StarsBg}
                          backgroundImage={preloadedAssets?.introBgImage}
                          backgroundColor={'#0d161e'}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images">
                            <Completion
                              questOptions={gameInfo?.questOptions}
                              getData={getData}
                              questState={questState}
                              setQuestState={setQuestState}
                              data={data}
                              setFeedbackNavigateNext={setFeedbackNavigateNext}
                              getFeedbackData={getFeedbackData}
                              gameInfo={gameInfo}
                              currentScreenId={currentScreenId}
                              setCurrentScreenId={setCurrentScreenId}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.backgroundImage}
                              screen={preloadedAssets.Screen1}
                              profile={profile}
                              currentQuestNo={currentQuestNo}
                              completionScreenQuestOptions={gameInfo?.gameQuest}
                              preloadedAssets={preloadedAssets}
                              setType={setType}
                              setData={setData}
                              type={type}
                              questWiseMaxTotal={questWiseMaxTotal} /// Pass questWiseMaxTotal as a prop
                              gameInfoTotalScore={
                                gameInfo?.completionQuestOptions
                              }
                              setProfile={setProfile}
                              getPrevLogDatas={getPrevLogDatas}
                              demoBlocks={demoBlocks}
                              setOptions={setOptions}
                              profileData={profileData}
                              feedbackList={feedbackList}
                              setFeedbackList={setFeedbackList}
                              setReplayState={setReplayState}
                              setReplayIsOpen={setReplayIsOpen}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 7:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          // backgroundImage={preloadedAssets.StarsBg}
                          backgroundImage={preloadedAssets?.introBgImage}
                          backgroundColor={'#0d161e'}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images">
                            <Takeway
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.Screen4}
                              getData={getData}
                              data={data}
                              preloadedAssets={preloadedAssets}
                              gameInfo={gameInfo}
                              setCurrentScreenId={setCurrentScreenId}
                              FeedbackcurrentPosition={FeedbackcurrentPosition}
                              setFeedbackCurrentPosition={
                                setFeedbackCurrentPosition
                              }
                              interactionBlockArray={interactionBlockArray}
                              profileData={profileData}
                              getFeedbackData={getFeedbackData}
                              feedbackList={feedbackList}
                              setInterActionBlockArray={
                                setInterActionBlockArray
                              }
                              setFeedbackNavigateNext={setFeedbackNavigateNext}
                              setCurrentQuestNo={setCurrentQuestNo}
                              setFirstLoading={setFirstLoading}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 8:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          backgroundImage={preloadedAssets.backgroundImage}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images">
                            <ReplayGame
                              replayGame={replayGame}
                              replayNextHandler={replayNextHandler}
                              type={type}
                              gameInfo={gameInfo}
                              setType={setType}
                              setData={setData}
                              isOptionalReplay={isOptionalReplay}
                              setisOptionalReplay={setisOptionalReplay}
                              setisReplay={setisReplay}
                              profilescore={profilescore}
                              isReplay={isReplay}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.Replay}
                              getData={getData}
                              data={data}
                              preloadedAssets={preloadedAssets}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 9:
                  return (
                    <>
                      {/* <InitialLoader /> */}
                      <FeedBackScreen
                        backgroundScreenUrl={preloadedAssets?.backgroundImage}
                        first={first}
                        showNote={showNote}
                        isScreenshot={isScreenshot}
                        setisScreenshot={setisScreenshot}
                        FeedbackremainingSentences={FeedbackremainingSentences}
                        options={options}
                        // setModalLoaded={setModalLoaded}
                        // modalLoaded={modalLoaded}
                        FeedBackselectedoptionData={FeedBackselectedoptionData}
                        FeedBackoptionData={FeedBackoptionData}
                        getFeedbackData={getFeedbackData}
                        data={data}
                        feed={feed}
                        currentScreenId={currentScreenId}
                        getData={getData}
                        profile={profile}
                        preloadedAssets={preloadedAssets}
                        firstLoading={firstLoading}
                        setFirstLoading={setFirstLoading}
                        setCurrentQuestNo={setCurrentQuestNo}
                        setNonPlayerNameLanguage={setNonPlayerNameLanguage}
                        NonPlayerNameLanguage={NonPlayerNameLanguage}
                      />
                    </>
                  );
                case 10:
                  return (
                    <GameIntroScreen
                      preloadedAssets={preloadedAssets}
                      setCurrentScreenId={setCurrentScreenId}
                      setIsGetsPlayAudioConfirmation={
                        setIsGetsPlayAudioConfirmation
                      }
                      setPreLogDatas={setPreLogDatas}
                      getPrevLogDatas={getPrevLogDatas}
                      currentScreenId={currentScreenId}
                      setModelControl={setModelControl}
                      ModelControl={ModelControl}
                      gameInfo={gameInfo.gameData}
                      hasMulitLanguages={hasMulitLanguages}
                      setIsOpenCustomModal={setIsOpenCustomModal}
                      setReplayState={setReplayState}
                      setReplayIsOpen={setReplayIsOpen}
                      setQuestState={setQuestState}
                      gameLanguages={gameLanguages}
                      isInitialLoadScreenWelcome={isInitialLoadScreenWelcome}
                      setIsInitialLoadScreenWelcome={
                        setIsInitialLoadScreenWelcome
                      }
                      profileData={profileData}
                      setProfileData={setProfileData}
                    />
                  );
                case 11:
                  return (
                    <>
                      <ProfileScreen
                        imageSrc={preloadedAssets.backgroundImage}
                        setCurrentScreenId={setCurrentScreenId}
                        profileData={profileData}
                        formData={gameInfo?.gameData}
                        setProfileData={setProfileData}
                        setPreLogDatas={setPreLogDatas}
                        preloadedAssets={preloadedAssets}
                        getPrevLogDatas={getPrevLogDatas}
                      />
                    </>
                  );

                case 12:
                  return (
                    <>
                      {/* <InitialLoader /> */}

                      <Characterspage
                        profileData={profileData}
                        setProfileData={setProfileData}
                        currentScreenId={currentScreenId}
                        setSelectedPlayer={setSelectedPlayer}
                        players={gameInfo?.gamePlayers}
                        formData={gameInfo?.gameData}
                        // imageSrc={preloadedAssets.StarsBg}
                        imageSrc={preloadedAssets?.introBgImage}
                        // backgroundImage={preloadedAssets?.introBgImage}
                        setCurrentScreenId={setCurrentScreenId}
                        demoBlocks={demoBlocks}
                        preloadedAssets={preloadedAssets}
                        setPreLogDatas={setPreLogDatas}
                        getPrevLogDatas={getPrevLogDatas}
                        ModelPlayer={ModelPlayer}
                        backgroundtheme={backgroundtheme}
                        selectedBackground={selectedBackground}
                      />
                    </>
                  );
                case 13:
                  return (
                    <>
                      {/* <Box className='black-shadow'> */}
                      <ChapterPage
                        setCurrentQuestNo={setCurrentQuestNo}
                        questState={questState}
                        setQuestState={setQuestState}
                        currentQuestNo={currentQuestNo}
                        formData={gameInfo?.gameData}
                        // imageSrc={preloadedAssets.StarsBg}
                        imageSrc={preloadedAssets?.introBgImage}
                        backgroundImg={preloadedAssets.backgroundImage}
                        demoBlocks={demoBlocks}
                        questOptions={gameInfo?.questOptions}
                        setCurrentScreenId={setCurrentScreenId}
                        setData={setData}
                        setType={setType}
                        setOptions={setOptions}
                        gameQuest={gameInfo?.gameQuest}
                        setFeedbackList={setFeedbackList}
                        preloadedAssets={preloadedAssets}
                        currentScreenId={currentScreenId}
                        setPreLogDatas={setPreLogDatas}
                        getPrevLogDatas={getPrevLogDatas}
                        profileData={profileData}
                        gameOptionSuffled={gameInfo?.gameData?.gameShuffle}
                        setRepeatPrevOption={setRepeatPrevOption}
                        setSelectedOption={setSelectedOption}
                        questWiseMaxTotal={questWiseMaxTotal}
                        gameInfoTotalScore={gameInfo?.completionQuestOptions}
                        gameInfo={gameInfo}
                        setIsZoomComplete={setIsZoomComplete}
                        isZoomComplete={isZoomComplete}
                      />
                    </>
                  );
                case 14:
                  return (
                    <FeedBackScreen
                      backgroundScreenUrl={preloadedAssets?.backgroundImage}
                      first={first}
                      showNote={showNote}
                      isScreenshot={isScreenshot}
                      FeedbackremainingSentences={FeedbackremainingSentences}
                      setisScreenshot={setisScreenshot}
                      options={options}
                      FeedBackselectedoptionData={FeedBackselectedoptionData}
                      FeedBackoptionData={FeedBackoptionData}
                      getFeedbackData={getFeedbackData}
                      data={data}
                      currentScreenId={currentScreenId}
                      getData={getData}
                      profile={profile}
                      preloadedAssets={preloadedAssets}
                      profileData={profileData}
                      interactionBlockArray={interactionBlockArray}
                      FeedbackcurrentPosition={FeedbackcurrentPosition}
                      setFeedbackCurrentPosition={setFeedbackCurrentPosition}
                      setCurrentScreenId={setCurrentScreenId}
                      gameInfo={gameInfo}
                      setAudioObj={setAudioObj}
                      firstLoading={firstLoading}
                      setFirstLoading={setFirstLoading}
                      InterActionScore={InterActionScore}
                      setCurrentQuestNo={setCurrentQuestNo}
                      setNonPlayerNameLanguage={setNonPlayerNameLanguage}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                    />
                  );
                case 15:
                  return (
                    <Overview
                      formData={gameInfo?.gameData}
                      imageSrc={preloadedAssets.overview}
                      preloadedAssets={preloadedAssets}
                      homeLeaderBoard={homeLeaderBoard}
                      setCurrentScreenId={setCurrentScreenId}
                      backGroundImg={preloadedAssets.backgroundImage}
                      profileData={profileData}
                    />
                  );
                  break;

                case 16:
                  return (
                    <ReplayPoints
                      setData={setData}
                      setType={setType}
                      preloadedAssets={preloadedAssets}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      setCurrentScreenId={setCurrentScreenId}
                      setModelScreen={setModelScreen}
                      modelScreen={modelScreen}
                      gameInfo={gameInfo}
                      profileData={profileData}
                      setOptions={setOptions}
                    />
                  );
                  break;

                default:
                  console.warn(
                    'game details of the data',
                    gameInfo?.gameData,
                    currentScreenId,
                  );
                  return <h1>Loading Screen .... Default case </h1>;
              }
            })()}
          </Flex>
          {isReviewDemo === true &&
            (!skipScreenList?.includes(currentScreenId) ? (
              <Menu isOpen={isMenuOpen}>
                <MenuButton
                  p="0px"
                  bg={'brandScheme'}
                  position={'fixed'}
                  bottom={'70px'}
                  right={'5px'}
                  className='review_mobile'
                  // zIndex={99999}
                  zIndex={replayState === 'replayPointPrompt' ? 99999 : 9}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                    handleMenubtn(e)
                  }
                >
                  <Icon
                    as={AiFillMessage}
                    bg={'#3311db'}
                    color={'#fff'}
                    w="60px"
                    h="60px"
                    borderRadius={'50%'}
                    p={'15px'}
                    me="10px"
                    className='review_icon'
                  />
                </MenuButton>
                {isMenuOpen && (
                  <MenuList
                    boxShadow={shadow}
                    p="20px"
                    me={{ base: '30px', md: 'unset' }}
                    borderRadius="20px"
                    bg={menuBg}
                    border="none"
                    mt="10px"
                    minW={{ base: '360px' }}
                    maxW={{ base: '360px', md: 'unset' }}
                    // zIndex={99999}
                    zIndex={replayState === 'replayPointPrompt' ? 99999 : 9}
                    className="review-menu-list"
                  >
                    {filteredTabOptions.length === 1 ? (
                      ''
                    ) : (
                      <>
                        <FormLabel
                          display="flex"
                          ms="10px"
                          fontSize="sm"
                          fontWeight="bold"
                        >
                          <Text fontSize="sm" fontWeight="400" ms="2px">
                            {'Feedback Options'}
                            <Text as="span" color="red.500">
                              *
                            </Text>
                          </Text>
                        </FormLabel>
                        <Select
                          mb="10px"
                          me="30px"
                          id="tab"
                          name="tab"
                          value={(reviewInput?.tabId ?? '') as string | number}
                          onChange={handleTabSelection}
                        >
                          <option value={''}>Select</option>
                          {filteredTabOptions.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Select>
                      </>
                    )}
                    {reviewInput?.tabId !== null &&
                      reviewInput?.tabId !== undefined &&
                      reviewSubTabOptions?.length > 0 && (
                        <>
                          <FormLabel
                            display="flex"
                            ms="10px"
                            fontSize="sm"
                            fontWeight="bold"
                          >
                            <Text fontSize="sm" fontWeight="400" ms="2px">
                              {'Secondary Options'}
                              <Text as="span" color="red.500">
                                *
                              </Text>
                            </Text>
                          </FormLabel>
                          <Select
                            mb="10px"
                            me="30px"
                            id="subtab"
                            name="subtab"
                            onChange={handleSubTabSelection}
                          >
                            <option value={''}>Select</option>
                            {reviewSubTabOptions.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </Select>
                        </>
                      )}
                    <FormControl>
                      <FormLabel fontSize={'sm'} fontWeight={700} pl="4">
                        Feedback
                      </FormLabel>
                      <Textarea
                        resize="none"
                        w="100%"
                        h="200px"
                        border="1px solid #CBD5E0"
                        borderRadius="20px"
                        p="4"
                        maxLength={200}
                        placeholder="Please Share your Thoughts..."
                        onChange={handleReview}
                        className="review-menu-feedback-textarea"
                      />
                      <Text color="grey" fontSize={{ base: 'sm', '2xl': 'md' }}>
                        {'Maximum of 200 characters...'}
                      </Text>
                    </FormControl>

                    <Checkbox
                      isChecked={CompleteReviewTrue}
                      onChange={() => setIsCompleteReview(true)}
                    >
                      Complete The Review Process
                    </Checkbox>

                    <MenuItem className="review-menu-submit-btn">
                      <Box
                        w={'100%'}
                        display={'flex'}
                        justifyContent={'flex-start'}
                      >
                        <Button
                          bg="#11047a"
                          _hover={{ bg: '#190793' }}
                          color="#fff"
                          h={'46px'}
                          w={'128px'}
                          mr={'33px'}
                          mt={'7px'}
                          onClick={() => hanldeClose()}
                        >
                          close
                        </Button>
                      </Box>

                      <Box
                        w={'100%'}
                        display={'flex'}
                        justifyContent={'flex-end'}
                      >
                        <Button
                          bg="#11047a"
                          _hover={{ bg: '#190793' }}
                          color="#fff"
                          h={'46px'}
                          w={'128px'}
                          mr={'33px'}
                          mt={'7px'}
                          onClick={() => hanldeSubmit(reviewInput)}
                          isDisabled={!isFormValid}
                        >
                          Submit
                        </Button>
                      </Box>
                    </MenuItem>
                  </MenuList>
                )}
              </Menu>
            ) : (
              <Box className={'static-page-instruction'}>
                <Text color={'whitesmoke'}>
                  This is a static page and cannot be reviewed.
                </Text>
              </Box>
            ))}

          {audioObj.type === EnumType.BGM && (
            <audio
              ref={backgroundBgmRef}
              loop={audioObj.loop}
              style={{ display: 'block' }}
            >
              <source src={audioObj.url} type="audio/mpeg" />
              Your browser does not support the audio tag.
            </audio>
          )}

          {/* Voice */}
          {audioObj.type === EnumType.VOICE && (
            <audio ref={voiceRef} style={{ display: 'block' }}>
              <source src={audioObj.url} type="audio/mpeg" />
              Your browser does not support the audio tag.
            </audio>
          )}
        </motion.div>
      ) : (
        ''
      )}
    </ProfileContext.Provider>
  );
};

export default EntirePreview;

function InitialLoader() {
  // return (
  //   <>
  //     <Box className="Entire-Loader" style={{ zIndex: '999999999 !important' }}>
  //       <motion.div
  //         className="Entire-Loader-wrapper"
  //         initial={{ opacity: 1 }}
  //         animate={{ opacity: 1 }}
  //         transition={{ duration: 1 }}
  //         style={{ zIndex: '99999999 !important',opacity: 1 }}
  //       >
  //         <Img
  //           src={LoadImg}
  //           className="load"
  //           style={{ zIndex: '99999999 !important',opacity: 1 }}
  //         />
  //       </motion.div>
  //     </Box>
  //   </>
  // );
  return (
    <>
      <Box className="Entire-Loader" style={{ zIndex: '999999999 !important' }}>
        <motion.div
          className="Entire-Loader-wrapper"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ zIndex: '99999999 !important',opacity: 1 }}
        >
          <Img
            src={LoadImg}
            className="load"
            style={{ zIndex: '99999999 !important',opacity: 1 }}
          />
        </motion.div>
      </Box>
    </>
  );

}


